webpackJsonp([0],{

/***/ "+950":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wysiwyg"}},[_c('div',{staticClass:"tools"},[(_vm.hideFile===undefined)?_c('div',{staticClass:"group-btn"},[_c('a',{attrs:{"title":"Apagar todo o texto"},on:{"click":function($event){_vm.fileNew()}}},[_c('i',{staticClass:"glyphicon glyphicon-file"})]),_vm._v(" "),_c('a',{staticClass:"hide",on:{"click":function($event){}}},[_c('i',{staticClass:"glyphicon glyphicon-folder-open"})]),_vm._v(" "),_c('a',{staticClass:"hide",on:{"click":function($event){}}},[_c('i',{staticClass:"glyphicon glyphicon-floppy-disk"})]),_vm._v(" "),_c('a',{on:{"click":function($event){}}},[_c('i',{staticClass:"glyphicon glyphicon-send"})])]):_vm._e(),_vm._v(" "),(_vm.hideBold===undefined)?_c('div',{staticClass:"group-btn"},[_c('a',{class:(_vm.btn.bold)? 'on' : '',attrs:{"title":"Negrito"},on:{"click":function($event){_vm.bold(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-bold"})]),_vm._v(" "),_c('a',{class:(_vm.btn.italic)? 'on' : '',attrs:{"title":"Italico"},on:{"click":function($event){_vm.italic(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-italic"})]),_vm._v(" "),_c('a',{class:(_vm.btn.underline)? 'on' : '',attrs:{"title":"Sublinhado"},on:{"click":function($event){_vm.underline(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-text-width"})]),_vm._v(" "),_c('a',{class:(_vm.btn.strikeThrough)? 'on' : '',attrs:{"title":"Tachado"},on:{"click":function($event){_vm.strikeThrough(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-gbp"})])]):_vm._e(),_vm._v(" "),(_vm.hideAlign===undefined)?_c('div',{staticClass:"group-btn"},[_c('a',{class:(_vm.btn.justifyLeft)? 'on' : '',attrs:{"title":"Esquerda"},on:{"click":function($event){_vm.justifyLeft()}}},[_c('i',{staticClass:"glyphicon glyphicon-align-left"})]),_vm._v(" "),_c('a',{class:(_vm.btn.justifyCenter)? 'on' : '',attrs:{"title":"Centro"},on:{"click":function($event){_vm.justifyCenter()}}},[_c('i',{staticClass:"glyphicon glyphicon-align-center"})]),_vm._v(" "),_c('a',{class:(_vm.btn.justifyRight)? 'on' : '',attrs:{"title":"Direita"},on:{"click":function($event){_vm.justifyRight()}}},[_c('i',{staticClass:"glyphicon glyphicon-align-right"})]),_vm._v(" "),_c('a',{class:(_vm.btn.justifyFull)? 'on' : '',attrs:{"title":"Justificado"},on:{"click":function($event){_vm.justifyFull()}}},[_c('i',{staticClass:"glyphicon glyphicon-align-justify"})])]):_vm._e(),_vm._v(" "),(_vm.hideColors===undefined)?_c('div',{staticClass:"group-btn"},[_c('a',{class:(_vm.btn.foreColor)? 'on' : '',on:{"click":function($event){_vm.foreColor(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-text-color"})]),_vm._v(" "),(!_vm.seeFontColors)?_c('a',{style:('color:' + _vm.foreColorHex),on:{"click":function($event){_vm.seeFontColors = !_vm.seeFontColors}}},[_c('i',{staticClass:"glyphicon glyphicon-stop"})]):_vm._e(),_vm._v(" "),(_vm.seeFontColors)?[_c('a',{on:{"click":function($event){_vm.setColor('#000', 'f')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#a94442', 'f')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-danger"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#337ab7', 'f')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-primary"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#3c763d', 'f')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-success"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#8a6d3b', 'f')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-warning"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#666', 'f')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-muted"})]),_vm._v(" "),_c('a',{staticStyle:{"color":"#aaa"},on:{"click":function($event){_vm.setColor('#fff', 'f')}}},[_c('i',{staticClass:"glyphicon glyphicon-text-background"})])]:_vm._e(),_vm._v(" "),(!_vm.seeFontColors)?_c('a',{on:{"click":function($event){_vm.removeFormat('foreColor')}}},[_c('i',{staticClass:"glyphicon glyphicon-erase"})]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.hideColors===undefined)?_c('div',{staticClass:"group-btn"},[_c('a',{class:(_vm.btn.backColor)? 'on' : '',attrs:{"title":"Cor de Fundo"},on:{"click":function($event){_vm.backColor(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-text-background"})]),_vm._v(" "),(!_vm.seeBackColors)?_c('a',{style:('color:' + _vm.backColorHex),attrs:{"title":"Escolher cor"},on:{"click":function($event){_vm.seeBackColors = !_vm.seeBackColors}}},[_c('i',{staticClass:"glyphicon glyphicon-stop"})]):_vm._e(),_vm._v(" "),(_vm.seeBackColors)?[_c('a',{on:{"click":function($event){_vm.setColor('#000', 'b')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#a94442', 'b')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-danger"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#337ab7', 'b')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-primary"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#3c763d', 'b')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-success"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#8a6d3b', 'b')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-warning"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.setColor('#666', 'b')}}},[_c('i',{staticClass:"glyphicon glyphicon-stop text-muted"})])]:_vm._e(),_vm._v(" "),(!_vm.seeBackColors)?_c('a',{on:{"click":function($event){_vm.removeFormat('backColor')}}},[_c('i',{staticClass:"glyphicon glyphicon-erase"})]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"group-btn"},[_c('a',{attrs:{"title":"Titulo"},on:{"click":function($event){_vm.fontSize('7')}}},[_vm._v("T1")]),_vm._v(" "),_c('a',{attrs:{"title":"Subtitulo"},on:{"click":function($event){_vm.fontSize('6')}}},[_vm._v("T2")])]),_vm._v(" "),_c('div',{staticClass:"group-btn"},[_c('a',{class:(_vm.btn.insertUnorderedList)? 'on' : '',on:{"click":function($event){_vm.insertUnorderedList(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-list"})]),_vm._v(" "),_c('a',{class:(_vm.btn.insertOrderedList)? 'on' : '',on:{"click":function($event){_vm.insertOrderedList(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-sort-by-order"})]),_vm._v(" "),_c('a',{class:(_vm.btn.superScript)? 'on' : '',on:{"click":function($event){_vm.superScript(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-superscript"})]),_vm._v(" "),_c('a',{class:(_vm.btn.subScript)? 'on' : '',on:{"click":function($event){_vm.subScript(true)}}},[_c('i',{staticClass:"glyphicon glyphicon-subscript"})])]),_vm._v(" "),(_vm.hideInserts===undefined)?_c('div',{staticClass:"group-btn"},[_c('a',{attrs:{"title":"Criar Link"},on:{"click":function($event){_vm.createLink()}}},[_c('i',{staticClass:"glyphicon glyphicon-link"})]),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.insertImage()}}},[_c('i',{staticClass:"glyphicon glyphicon-paperclip"})])]):_vm._e()]),_vm._v(" "),_c('div',{ref:"editor",staticClass:"resize",attrs:{"id":"editor","contenteditable":""},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.handlerKeyEnter()},function($event){_vm.updateCaretInfo()}],"mousedown":function($event){_vm.handlerMouseDown()},"mouseup":function($event){_vm.handlerMouseUp()},"keydown":function($event){_vm.updateCaretInfo()},"focus":function($event){_vm.active = true},"focusout":function($event){_vm.active = false}}}),_vm._v(" "),_c('small',[_c('small',[_vm._v(_vm._s(_vm.caret.pathList !== undefined ? _vm.caret.pathList : ''))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Xm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Mask from './Mask.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userlist',
  data: function data() {
    return {
      loading: false,
      users: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getuser.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.length > 0) {
          this.users = response.body;
        } else {
          this.users = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/usuario/' + cod });
    },
    select4agenda: function select4agenda(cod) {
      this.$router.push({ path: '/agenda/c/' + cod });
    }
  },
  created: function created() {
    this.load({ 'rel': 'all' });
  },
  watch: {
    '$route': function $route(to, from) {
      this.load({ 'rel': 'all' });
    }
  }
});

/***/ }),

/***/ "/Hd2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/wwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-12 text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/clientes/cob"}},[_vm._v("Cobrança")]),_vm._v(" » Docs\n    ")],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.clientes.length)+" resultado(s) encontrados")]),_vm._v(" "),(this.$route.query.s)?_c('small',[_vm._v(" que contém '"+_vm._s(this.$route.query.s)+"'")]):_vm._e()]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.clientes),function(cliente,index){return _c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(cliente.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-book",attrs:{"title":"Agenda"},on:{"click":function($event){$event.preventDefault();_vm.select4agenda(cliente.cod)}}})]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(_vm.maskCnpj(cliente.cnpj)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.razao)),_c('br'),_c('small',[_vm._v(_vm._s(cliente.fantasia))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(cliente.emailnfse)?_c('a',{attrs:{"href":_vm.nfseMailLink(cliente.email)}},[_c('i',{staticClass:"glyphicon glyphicon-envelope",on:{"click":function($event){_vm.verify($event)}}})]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(cliente.emailboleto)?_c('a',{attrs:{"href":_vm.boletoMailLink(cliente.email)}},[_c('i',{staticClass:"glyphicon glyphicon-envelope",on:{"click":function($event){_vm.verify($event)}}})]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.cobdia))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.maskMonetario(cliente.cobvalor, true)))]),_vm._v(" "),_c('td',_vm._l((cliente.telefone),function(telefone){return _c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero))),_c('br')])}))])})],2),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("cnpj")]),_vm._v(" "),_c('td',[_vm._v("razao")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("NFS-e")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("BOLETO")]),_vm._v(" "),_c('td',[_vm._v("dia")]),_vm._v(" "),_c('td',[_vm._v("valor")]),_vm._v(" "),_c('td',[_vm._v("contato")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0mWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_root"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/manuais"}},[_vm._v("Manual")]),_vm._v(" » "+_vm._s(_vm.crud_action)+"\n      "),(!_vm.loading)?_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Salvar")]):_c('button',{staticClass:"btn btn-muted pull-right"},[_vm._v("Aguarde...")])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Titulo e Resumo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.titulo),expression:"form.titulo"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"","placeholder":"Título e Resumo"},domProps:{"value":(_vm.form.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "titulo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Categoria")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cat),expression:"form.cat"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "cat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Psweb"}},[_vm._v("Psweb")]),_vm._v(" "),_c('option',{attrs:{"value":"Cupom Fiscal-CF"}},[_vm._v("Cupom Fiscal")]),_vm._v(" "),_c('option',{attrs:{"value":"Cupom Eletrônico-NFCE"}},[_vm._v("Cupom Eletrônico")]),_vm._v(" "),_c('option',{attrs:{"value":"Nota Eletrônica-NFE"}},[_vm._v("Nota Eletrônica")]),_vm._v(" "),_c('option',{attrs:{"value":"Manifesto Eletrônico-MDFE"}},[_vm._v("Manifesto Eletrônico")]),_vm._v(" "),_c('option',{attrs:{"value":"Postgres"}},[_vm._v("Postgres")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("SubCategoria")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.subcat),expression:"form.subcat"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "subcat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"Autorização/Erros"}},[_vm._v("Autorização/Erros")]),_vm._v(" "),_c('option',{attrs:{"value":"Problemas comuns"}},[_vm._v("Problemas comuns")]),_vm._v(" "),_c('option',{attrs:{"value":"Sqls"}},[_vm._v("SQLs")]),_vm._v(" "),_c('option',{attrs:{"value":"Configurações"}},[_vm._v("Configuração")]),_vm._v(" "),_c('option',{attrs:{"value":"Legislação/Regulam."}},[_vm._v("Legislação/Regulam.")]),_vm._v(" "),_c('option',{attrs:{"value":"Instalação"}},[_vm._v("Instalação")]),_vm._v(" "),_c('option',{attrs:{"value":"Impressoras"}},[_vm._v("Impressoras")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tags),expression:"form.tags"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"","placeholder":"Ex: psweb acbr"},domProps:{"value":(_vm.form.tags)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "tags", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('label',{staticClass:"control-label"},[_vm._v("Manual")]),_vm._v(" "),_c('wysiwyg',{ref:"manual"})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Tags "),_c('small',[_vm._v("(Palavras chave minusculas separadas por espaço)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0txO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-12 text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/manuais"}},[_vm._v("Manuais")])],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(this.$route.query.c)+" » "+_vm._s(this.$route.query.sc!==undefined? this.$route.query.sc : '*'))])]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.manuais),function(man){return _c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(man.cod)}}})]),_vm._v(" "),_c('td',[_vm._v("<>")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(man.titulo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(man.tags))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatData(man.dt_insert)))])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("#")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Titulo")]),_vm._v(" "),_c('td',[_vm._v("Tags")]),_vm._v(" "),_c('td',[_vm._v("Data")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0vvI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManForm_vue__ = __webpack_require__("YdJY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70563765_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManForm_vue__ = __webpack_require__("0mWB");
function injectStyle (ssrContext) {
  __webpack_require__("zZ/U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70563765"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70563765_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "15CE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pacote',
  components: {},
  data: function data() {
    return {
      logado: false
    };
  },

  methods: {},
  created: function created() {
    this.logado = this.$root.auth;
  }
});

/***/ }),

/***/ "15ZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Email',
  components: {},
  data: function data() {
    return {
      logado: false
    };
  },

  methods: {},
  created: function created() {
    this.logado = this.$root.auth;
  }
});

/***/ }),

/***/ "1nYz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/mensagens"}},[_vm._v("Mensagens")]),_vm._v(" » Selecione os clientes\n      "),(!_vm.loading)?_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.saveList()}}},[_vm._v("Salvar")]):_c('button',{staticClass:"btn btn-muted pull-right"},[_vm._v("Aguarde...")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-left"},[_c('b',[_vm._v("Mensagem")]),_vm._v(" #"+_vm._s(_vm.msg.cod)+". Visível de "),_c('b',[_vm._v(_vm._s(_vm.formatData(_vm.msg.dt_inicio)))]),_vm._v(" até "),_c('b',[_vm._v(_vm._s(_vm.formatData(_vm.msg.dt_fim)))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 msgdisplay"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg.msg)}})]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.chaves),function(chave){return _c('tr',{class:chave.status? 'bg-primary' : ''},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(chave.status),expression:"chave.status"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(chave.status)?_vm._i(chave.status,null)>-1:(chave.status)},on:{"change":function($event){var $$a=chave.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(chave.status=$$a.concat([$$v]))}else{$$i>-1&&(chave.status=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(chave, "status", $$c)}}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(chave.cliente===''? 'Sem chave no HUB' : chave.cliente))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(chave.qtd))])])}),_vm._v(" "),_c('tr',[_c('td',[_c('input',{ref:"iptselectall",attrs:{"type":"checkbox"},on:{"click":function($event){_vm.selectAll()}}}),_vm._v(" "),(!_vm.iptSelectBool)?_c('label',{staticClass:"control-form",attrs:{"for":""}},[_vm._v("Marcar Todos")]):_c('label',{staticClass:"control-form",attrs:{"for":""}},[_vm._v("Desmarcar Todos")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("#")]),_vm._v(" "),_c('td',[_vm._v("PSWEB chave CLIENTE pos.16")]),_vm._v(" "),_c('td',[_vm._v("Qtd.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "25R1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'acesso',
  props: ['acessos'],
  data: function data() {
    return {
      showform: false,
      iptEndereco: '',
      iptDescricao: '',
      iptUsuario: '',
      iptSenha: '',
      index: -1
    };
  },

  methods: {
    add: function add() {
      var item = { 'endereco': this.iptEndereco, 'descricao': this.iptDescricao, 'u': this.iptUsuario, 's': this.iptSenha };
      this.$emit('add', item, 'acesso', this.index);
      this.reset();
    },
    update: function update(index) {
      var acesso = this.acessos[index];
      this.iptEndereco = acesso.endereco;
      this.iptDescricao = acesso.descricao;
      this.iptUsuario = acesso.u;
      this.iptSenha = acesso.s;
      this.index = index;
      this.showform = true;
      this.focus();
    },
    remove: function remove(index) {
      this.$emit('remove', 'acesso', index);
    },
    focus: function focus() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.iptendereco.focus();
      });
    },
    reset: function reset() {
      this.showform = false;
      this.iptEndereco = '';
      this.iptDescricao = '';
      this.iptUsuario = '';
      this.iptSenha = '';
      this.index = -1;
    }
  }
});

/***/ }),

/***/ "2MWw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserRel_vue__ = __webpack_require__("+Xm6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56c07a16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserRel_vue__ = __webpack_require__("aYBc");
function injectStyle (ssrContext) {
  __webpack_require__("axs+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56c07a16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserRel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56c07a16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserRel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2T5x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userlist',
  data: function data() {
    return {
      loading: false,
      mensagens: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getmsg.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.mensagens = response.body.rows;
        } else {
          this.mensagens = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/mensagem/u/' + cod });
    },
    select4list: function select4list(cod) {
      this.$router.push({ path: '/mensagens/' + cod });
    }
  },
  created: function created() {
    this.load({ 'rel': true });
  },
  watch: {
    '$route': function $route(to, from) {
      this.load({ 'rel': true });
    }
  }
});

/***/ }),

/***/ "2dnT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zjs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3EzT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4HYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manuais_vue__ = __webpack_require__("byFV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e1b392_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Manuais_vue__ = __webpack_require__("PeDx");
function injectStyle (ssrContext) {
  __webpack_require__("7LQ/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e1e1b392"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Manuais_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1e1b392_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Manuais_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4a3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormEndereco_vue__ = __webpack_require__("VglG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a85994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormEndereco_vue__ = __webpack_require__("9DiD");
function injectStyle (ssrContext) {
  __webpack_require__("Tb1r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormEndereco_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a85994_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormEndereco_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4t5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormAcesso_vue__ = __webpack_require__("25R1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fda2892_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormAcesso_vue__ = __webpack_require__("pUCz");
function injectStyle (ssrContext) {
  __webpack_require__("8auI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fda2892"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormAcesso_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fda2892_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormAcesso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Qph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-12 text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/clientes/cob"}},[_vm._v("Cobrança")]),_vm._v(" | \n      "),_c('router-link',{attrs:{"to":"/clientes/sup"}},[_vm._v("Suporte")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.addNew()}}},[_vm._v("Novo Cliente")])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.clientes.length)+" resultado(s) encontrados")]),_vm._v(" "),(this.$route.query.s)?_c('small',[_vm._v(" que contém '"+_vm._s(this.$route.query.s)+"'")]):_vm._e()]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.clientes),function(cliente){return _c('tr',{class:cliente.situacao==='2'? 'text-danger bg-danger' : ''},[_c('td',{staticClass:"nowrap"},[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(cliente.cod)}}}),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-book",attrs:{"title":"Agenda"},on:{"click":function($event){$event.preventDefault();_vm.select4agenda(cliente.cod)}}}),_vm._v(" "),(cliente.grupo)?_c('a',{staticClass:"glyphicon glyphicon-th-large",attrs:{"title":cliente.grupo},on:{"click":function($event){$event.preventDefault();_vm.select4grupo(cliente.grupo)}}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(_vm.maskCnpj(cliente.cnpj)))]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(cliente.razao)),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(cliente.fantasia))]),_vm._v(" "),(cliente.situacao==='2')?_c('b',{staticClass:"bg-danger text-danger"},[_c('i',{staticClass:"glyphicon glyphicon-lock"}),_vm._v("Bloqueado. Não Atender!")]):_vm._e(),_vm._v(" "),(cliente.situacao==='0')?_c('b',{staticClass:"bg-warning text-danger"},[_c('i',{staticClass:"glyphicon glyphicon-delete"}),_vm._v("Ex Cliente. Não Atender!")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.endcidade !== '' ? cliente.endcidade : cliente.cobcidade))]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(cliente.chavecliente))]),_vm._v(" "),_c('td',{staticClass:"lt500"},[(cliente.certificado!=='A1')?_c('div',{staticClass:"label label-danger"},[_vm._v(_vm._s(cliente.certificado))]):_vm._e(),_vm._v(" "),(cliente.uso==='linux')?_c('div',{staticClass:"label label-success"},[_vm._v("Linux")]):_vm._e(),_vm._v(" "),(cliente.situacao==='3')?_c('div',{staticClass:"label label-warning"},[_vm._v("Antigo")]):_vm._e(),_vm._v(" "),(cliente.unfe!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.unfe))}}):_vm._e(),_vm._v(" "),(cliente.ucfe!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.ucfe))}}):_vm._e(),_vm._v(" "),(cliente.unfse!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.unfse))}}):_vm._e(),_vm._v(" "),(cliente.umdfe!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.umdfe))}}):_vm._e(),_vm._v(" "),(cliente.ucte!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.ucte))}}):_vm._e(),_vm._v(" "),(cliente.uetiq!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.uetiq))}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(cliente.cobdia))]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(_vm.maskMonetario(cliente.cobvalor, true)))]),_vm._v(" "),_c('td',_vm._l((cliente.telefone),function(telefone){return _c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero))),_c('br')])}))])})],2),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("cnpj")]),_vm._v(" "),_c('td',[_vm._v("razao")]),_vm._v(" "),_c('td',[_vm._v("cidade")]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("chave")]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("uso")]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("dia")]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("valor")]),_vm._v(" "),_c('td',[_vm._v("contato")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6Aj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__ = __webpack_require__("15ZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282e9283_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__ = __webpack_require__("UJ21");
function injectStyle (ssrContext) {
  __webpack_require__("lMu7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-282e9283"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282e9283_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6qAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FerRel_vue__ = __webpack_require__("flJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c656f2f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FerRel_vue__ = __webpack_require__("y4sZ");
function injectStyle (ssrContext) {
  __webpack_require__("RUbm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c656f2f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FerRel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c656f2f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FerRel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7B7v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7IkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.state.isBusy)?_c('div',{staticClass:"info"},[_c('h1',[_vm._v("Envio automático")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.state.curr)+" de "+_vm._s(_vm.state.total))]),_vm._v(" "),_c('h5',[_vm._v(_vm._s(_vm.state.email))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/Emails"}},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.sendAuto(10)}}},[_vm._v("Enviar 10")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.sendAuto(25)}}},[_vm._v("Enviar 25")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.sendAuto(50)}}},[_vm._v("Enviar 50")])])],1),_vm._v(" "),_c('h4',[_vm._v("Assunto:"+_vm._s(_vm.mail.assunto))]),_vm._v(" "),_c('small',[_vm._v("Atualmente enviados "),_c('b',[_vm._v(_vm._s(_vm.clientes.length-_vm.maillist.clientes.length))]),_vm._v(" de "),_c('b',[_vm._v(_vm._s(_vm.clientes.length))]),_vm._v(" destinatários deste email.")]),_vm._v(" "),(this.$route.query.s)?_c('small',[_vm._v(" que contém '"+_vm._s(this.$route.query.s)+"'")]):_vm._e()]),_vm._v(" "),_c('table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.state.isBusy),expression:"!state.isBusy"}]},[_vm._m(0),_vm._v(" "),_vm._l((_vm.clientes),function(cliente){return _c('tr',{class:cliente.status? 'bg-success text-success' : ''},[_c('td',[(!cliente.status)?_c('a',{staticClass:"glyphicon glyphicon-envelope",attrs:{"title":'Enviar para '+cliente.email},on:{"click":function($event){$event.preventDefault();_vm.sendMail(cliente.email)}}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.maskCnpj(cliente.cnpj)))]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(cliente.razao)),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(cliente.fantasia))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.endcidade !== '' ? cliente.endcidade : cliente.cobcidade))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.email))])])})],2),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v("cnpj")]),_vm._v(" "),_c('td',[_vm._v("razao")]),_vm._v(" "),_c('td',[_vm._v("cidade")]),_vm._v(" "),_c('td',[_vm._v("email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7LQ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8auI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8iUb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__ = __webpack_require__("D+ug");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01460cd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__ = __webpack_require__("n4ez");
function injectStyle (ssrContext) {
  __webpack_require__("pgFT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01460cd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01460cd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8mIE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Agenda',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "95lI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__ = __webpack_require__("iyFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mask_js__ = __webpack_require__("HVS0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Calendario: __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showCalendar: false,
      crud: undefined,
      form: {
        cod: 0,
        codcli: undefined,
        codfuncionario: '1',
        codautor: '1',
        descricao: '',
        dt: '',
        hora: '08:30',
        situacao: '',
        excluido: false
      },
      cliente: {},
      compromissos: {}
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getagenda.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        this.fetchData(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    loadAgendaDate: function loadAgendaDate(date) {
      var url = './api/php/getagenda.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'adate': date })).then(function (response) {
        this.compromissos = response.body;
      }, function (error) {
        console.log(error);
      });
    },
    loadCliente: function loadCliente(cod) {
      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'cod': cod })).then(function (response) {
        // console.log(response.body)
        this.fetchDataCliente(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    loadTarefas: function loadTarefas(cod) {
      var url = './api/php/gettarefa.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'codcli': cod })).then(function (response) {
        if (response.body.length > 0) {
          this.fetchDataTarefasPendentes(response.body);
        } else {
          console.log('Nenhuma tarefa para visita no HUB');
        }
      }, function (error) {
        console.log(error);
      });
    },
    save: function save() {
      delete this.form['funcionarionome'];
      var url = './api/php/addagenda.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form)).then(function (response) {
        console.log(response.body);
        if (this.crud === 'c') {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Agendado com sucesso', 'Compromisso agendado com ' + this.cliente.razao + ' para as ' + this.form.hora + ' do dia ' + this.formatData(this.form.dt), 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Alterado com Sucesso', '', 'success');
        }
        this.closeForm();
      }, function (error) {
        console.log(error);
      });
    },
    remove: function remove() {
      var cod = this.form.cod;
      var url = './api/php/removeagenda.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'cod': cod })).then(function (response) {
        // console.log(response.body)
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Excluído com sucesso', '', 'success');
        this.closeForm();
      }, function (error) {
        console.log(error);
      });
    },
    fetchData: function fetchData(o) {
      console.log('Try fetch data');
      this.form = o;
      this.form.hora = __WEBPACK_IMPORTED_MODULE_2__Mask_js__["a" /* default */].hora(o.hora);
      this.loadCliente(this.form.codcli);
      this.loadAgendaDate(this.form.dt);
    },
    fetchDataCliente: function fetchDataCliente(o) {
      this.form.codcli = o.cod;
      this.cliente = o;
      var pfix = 'cob';
      if (o.endrua !== '') pfix = 'end';
      this.cliente['endereco'] = o[pfix + 'rua'] + ', ' + o[pfix + 'numero'] + ' ' + o[pfix + 'compl'] + '. ' + o[pfix + 'bairro'] + ' - ' + o[pfix + 'cidade'] + ' / ' + o[pfix + 'uf'];
      this.loadTarefas(this.form.codcli);
    },
    fetchDataTarefasPendentes: function fetchDataTarefasPendentes(o) {
      var txt = '\n\n';
      txt += '=====================\n';
      txt += 'TAREFAS PENDENTES HUB\n';
      txt += '=====================\n';
      o.forEach(function (tarefa) {
        txt += '[#' + tarefa.cod + '] ' + tarefa.descr + '\n--------------------\n';
      });
      txt += 'Avisar que concluiu alguma tarefa do hub.';
      this.form.descricao += txt;
    },
    setDate: function setDate(date) {
      this.form.dt = date;
      this.showCalendar = false;
      this.loadAgendaDate(date);
    },
    formatData: function formatData(date) {
      if (date.length > 0) {
        return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4);
      }
    },
    closeForm: function closeForm() {
      this.$router.go(-1);
    },
    maskHora: function maskHora(e) {
      e.target.value = __WEBPACK_IMPORTED_MODULE_2__Mask_js__["a" /* default */].hora(e.target.value);
    }
  },
  created: function created() {
    var _this = this;

    var crud = this.$route.params.crud;
    var cod = this.$route.params.id;
    if (crud === 'c') {
      // Criar novo compromisso
      console.log('Criando novo compromisso');
      this.form.codautor = this.$root.cod;
      this.loadCliente(cod);
      if (this.$root.globalAgeFormDt !== undefined) {
        this.setDate(this.$root.globalAgeFormDt);
        this.$root.globalAgeFormDt = undefined;
      }
    } else if (crud === 'u') {
      // Altera um compromisso
      console.log('Alterando compromisso');
      this.load({ 'cod': cod });
    } else {
      console.log('CRUD INVÁLIDO NO ACESSO AO FORM');
    }
    this.crud = crud;
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_2__Mask_js__["a" /* default */].telefone;
    this.$nextTick(function () {
      _this.$refs.iptdescricao.focus();
    });
  }
});

/***/ }),

/***/ "9DiD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-sm-12",attrs:{"for":"ipt_cod"}},[_vm._v("\n      Endereço "+_vm._s(_vm.title)+"\n      "),_c('a',{staticClass:"glyphicon glyphicon-globe",attrs:{"href":_vm.googleLink(),"target":"_blank","title":"Google Maps"}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.rua),expression:"ender.rua"}],staticClass:"form-control up",attrs:{"type":"text","maxlength":"50","placeholder":"Logradouro"},domProps:{"value":(_vm.ender.rua)},on:{"focusout":function($event){_vm.add('rua',_vm.ender.rua)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "rua", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.numero),expression:"ender.numero"}],staticClass:"form-control up",attrs:{"type":"text","placeholder":"Número"},domProps:{"value":(_vm.ender.numero)},on:{"focusout":function($event){_vm.add('numero',_vm.ender.numero)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "numero", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.compl),expression:"ender.compl"}],staticClass:"form-control up",attrs:{"type":"text","maxlength":"10","placeholder":"Complemento"},domProps:{"value":(_vm.ender.compl)},on:{"focusout":function($event){_vm.add('compl',_vm.ender.compl)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "compl", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.cep),expression:"ender.cep"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Cep"},domProps:{"value":(_vm.ender.cep)},on:{"focusout":function($event){_vm.maskCepInput($event);_vm.add('cep',_vm.ender.cep)},"keydown":function($event){_vm.maskCepInput($event)},"keyup":function($event){_vm.maskCepInput($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "cep", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.bairro),expression:"ender.bairro"}],staticClass:"form-control up",attrs:{"type":"text","maxlength":"20","placeholder":"Bairro"},domProps:{"value":(_vm.ender.bairro)},on:{"focusout":function($event){_vm.add('bairro',_vm.ender.bairro)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "bairro", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.cidade),expression:"ender.cidade"}],staticClass:"form-control up",attrs:{"type":"text","maxlength":"20","placeholder":"Cidade"},domProps:{"value":(_vm.ender.cidade)},on:{"focusout":function($event){_vm.add('cidade',_vm.ender.cidade)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "cidade", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.uf),expression:"ender.uf"}],staticClass:"form-control up",attrs:{"type":"text","maxlength":"2","placeholder":"UF"},domProps:{"value":(_vm.ender.uf)},on:{"focusout":function($event){_vm.add('uf',_vm.ender.uf)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "uf", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-11"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ender.referencia),expression:"ender.referencia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Referências, detalhes"},domProps:{"value":(_vm.ender.referencia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ender, "referencia", $event.target.value)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9JAD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailRelSend_vue__ = __webpack_require__("FV1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f110b6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailRelSend_vue__ = __webpack_require__("7IkT");
function injectStyle (ssrContext) {
  __webpack_require__("i8lr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f110b6e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailRelSend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f110b6e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailRelSend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9yT+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mensagem_vue__ = __webpack_require__("t6hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f35ad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mensagem_vue__ = __webpack_require__("J0Zt");
function injectStyle (ssrContext) {
  __webpack_require__("jJE4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00f35ad8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mensagem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00f35ad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mensagem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AELy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BJz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_root"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/mensagens"}},[_vm._v("Mensagem")]),_vm._v(" » "+_vm._s(_vm.crud_action)+"\n      "),(!_vm.loading)?_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Salvar")]):_c('button',{staticClass:"btn btn-muted pull-right"},[_vm._v("Aguarde...")])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Mensagem")]),_vm._v(" "),_c('wysiwyg',{ref:"msg",attrs:{"hideFile":"true","hideAlign":"true","hideInserts":"true"}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{ref:"dtiniciodisplay",staticClass:"form-control",attrs:{"value":"","type":"text","disabled":""}}),_vm._v(" "),(_vm.showCalendarDtInicio)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDate}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendarDtInicio=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})])])],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{ref:"dtfimdisplay",staticClass:"form-control",attrs:{"value":"","type":"text","disabled":""}}),_vm._v(" "),(_vm.showCalendarDtFim)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDate}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendarDtFim=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})])])],1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.atucodig),expression:"form.atucodig"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Um cód. por mensagem"},domProps:{"value":(_vm.form.atucodig)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "atucodig", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-center"},[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){$event.preventDefault();_vm.remove()}}},[_vm._v("Excluir Mensagem")])]),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Data Início")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('br'),_vm._v(" "),_c('label',{attrs:{"for":""}},[_vm._v("Data Término")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('br'),_vm._v(" "),_c('label',[_vm._v("Ref. Atualização Cód.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BM48":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgeForm_vue__ = __webpack_require__("95lI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e22d3ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgeForm_vue__ = __webpack_require__("bjgq");
function injectStyle (ssrContext) {
  __webpack_require__("GF/y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e22d3ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e22d3ec_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BTBH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CKsO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+ug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userform',
  components: {},
  data: function data() {
    return {
      crud_action: '',
      pass: '',
      form: {
        cod: 0,
        login: '',
        pass: '',
        nome: '',
        nivel: '0'
      }
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getuser.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response);
        this.form = response.body;
      }, function (error) {
        console.log(error);
      });
    },
    save: function save(form) {
      var url = './api/php/adduser.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(form)).then(function (response) {
        console.log(response.body);
        if (form.cod === 0) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Sucesso', form.nome + ' adicionado a lista de usuarios', 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Sucesso', form.nome + ' alterado com sucesso', 'success');
        }
        this.closeForm();
      }, function (error) {
        console.log(error);
      });
    },
    saveForm: function saveForm() {
      if (this.pass !== this.form.pass) {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'As senhas de acesso e confirmação são diferentes!', 'error');
        this.pass = '';
        this.form.pass = '';
      } else if (this.form.login === '' || this.form.nome === '') {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('error', 'Login e Nome são campos obrigatórios', 'error');
      } else {
        this.save(this.form);
      }
    },
    remove: function remove() {
      var cod = this.form.cod;
      var url = './api/php/removeuser.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'cod': cod })).then(function (response) {
        // console.log(response.body)
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Excluído com sucesso', this.form.nome + ' foi excluído.', 'success');
      }, function (error) {
        console.log(error);
      });
    },
    closeForm: function closeForm() {
      this.$router.push({ path: '/usuarios' });
    }
  },
  created: function created() {
    var cod = parseInt(this.$route.params.id);
    if (cod === 0) {
      this.crud_action = 'Novo';
    } else if (cod > 0) {
      this.crud_action = 'Alterando';
      this.load({ 'cod': cod });
    }
  }
});

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navbar',
  data: function data() {
    return {
      nivel: -1,
      isVisibleMenu: false
    };
  },

  methods: {
    search: function search() {
      var keyword = this.$refs.iptSearchKeyword.value + this.$refs.iptSearchKeyword2.value;
      this.$router.push({ path: this.$route.path, query: { s: keyword } });
    },
    cleanSearch: function cleanSearch() {
      this.$refs.iptSearchKeyword.value = '';
    },
    logout: function logout() {
      this.$emit('logout');
    },
    displayMenu: function displayMenu() {
      this.isVisibleMenu = !this.isVisibleMenu;
    },
    focusIptSearch: function focusIptSearch() {
      var _this = this;

      if (this.$refs.iptSearchKeyword === undefined) {
        this.$nextTick(function () {
          _this.$refs.iptSearchKeyword.focus();
        });
      } else {
        this.$nextTick(function () {
          _this.$refs.iptSearchKeyword2.focus();
        });
      }
    }
  },
  created: function created() {
    this.nivel = this.$root.nivel;
  },
  watch: {
    '$route': function $route(to, from) {
      this.nivel = this.$root.nivel;
      if (this.$route.query.s === undefined) {
        this.cleanSearch();
      }
      if (this.isVisibleMenu) {
        this.displayMenu();
      }
    }
  }
});

/***/ }),

/***/ "FU+i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FV1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist',
  data: function data() {
    return {
      state: {
        isBusy: false,
        curr: 0,
        total: 0,
        email: ''
      },
      clientes: [],
      mail: {
        cod: 0,
        assunto: 'Teste do email',
        conteudo: '<b>Corpo</b> do email'
      },
      maillist: {
        clientes: []
      }
    };
  },

  methods: {
    send: function send() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      console.log('Try Send...');
      var url = './api/php/sendmail.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          console.log('Try Confirm...' + this.mail.cod + ' ' + params.destinatario);
          this.confirmSend({ 'cod': this.mail.cod, 'email': params.destinatario });
        } else {
          console.log('Ocorreu um erro ao enviar o email');
          console.log(response.body.error);
        }
      }, function (error) {
        console.log(error);
      });
    },
    sendMail: function sendMail(email) {
      this.send({ 'assunto': this.mail.assunto, 'conteudo': this.mail.conteudo, 'destinatario': email });
    },
    sendAuto: function sendAuto(qtd) {
      this.state.isBusy = true;
      this.state.curr = 0;
      this.state.total = qtd;
      this.filterPendentes();
    },
    confirmSend: function confirmSend() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      console.log('Try confirm...');
      var url = './api/php/confirmsend.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.updateMailList(response.body.email);
        } else {
          console.log(response.body);
        }
      }, function (error) {
        console.log(error);
      });
    },
    updateMailList: function updateMailList(email) {
      var l = this.clientes.length;
      for (var i = 0; i < l; i++) {
        if (this.clientes[i].email === email) {
          this.clientes[i].status = true;
        }
      }
      this.filterPendentes();
    },
    loadEmail: function loadEmail() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getemail.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body.assunto);
        if (response.body.cod !== undefined) {
          this.mail = response.body;
          this.loadEmailList({ 'cod': this.mail.cod });
        } else {
          console.log('Não foi possível carregar o email');
        }
      }, function (error) {
        console.log(error);
      });
    },
    loadEmailList: function loadEmailList() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getemaillist.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.clientes = response.body.rows;
          this.filterPendentes();
          console.log(this.maillist.clientes.length);
        } else {
          console.log(response.body.error);
        }
      }, function (error) {
        console.log(error);
      });
    },
    filterPendentes: function filterPendentes() {
      this.maillist.clientes = this.clientes.filter(function (cliente) {
        return !cliente.status;
      });
      if (this.state.isBusy === true && this.state.curr < this.state.total) {
        this.state.curr++;
        this.state.email = this.maillist.clientes[0].email;
        this.sendMail(this.state.email);
      } else {
        this.state.isBusy = false;
        this.state.curr = 0;
        this.state.total = 0;
        this.state.email = '';
      }
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/cliente/' + cod });
    }
  },
  created: function created() {
    this.maskCnpj = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].cnpj;
    this.maskMonetario = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].monetario;
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].telefone;
    // const keyword = this.$route.query.s
    var cod = this.$route.params.id;
    this.loadEmail({ 'cod': cod });
  },
  watch: {
    '$route': function $route(to, from) {
      // const keyword = this.$route.query.s
      var cod = this.$route.params.id;
      this.loadEmail({ 'cod': cod });
    }
  }
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      logado: false,
      smart: {
        agenda: false,
        tarefas: false
      }
    };
  },

  methods: {
    loadSmartAgenda: function loadSmartAgenda() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getagenda.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'codfuncionario': this.$root.cod })).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.smart.agenda = response.body.rows;
        }
      }, function (error) {
        console.log(error);
      });
    },
    loadSmartTarefas: function loadSmartTarefas() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/gettarefa.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.length > 0) {
          this.smart.tarefas = response.body;
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4tarefa: function select4tarefa(cod) {
      this.$router.push({ path: '/tarefa/u/' + cod });
    },
    select4agenda: function select4agenda(cod) {
      this.$router.push({ path: '/agenda/u/' + cod });
    }
  },
  created: function created() {
    this.logado = this.$root.auth;
    this.loadSmartAgenda();
    // Conf busca de tarefas
    var filters = {};
    filters.flag = '*';
    filters.coduser = this.$root.cod;
    filters.situacao = '2';
    filters.dtmin = '1900-01-01 00:00:00';
    filters.dtmax = '9999-12-31 23:59:59';
    this.loadSmartTarefas({ 'filters': filters });
  }
});

/***/ }),

/***/ "Fw8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormTelefone_vue__ = __webpack_require__("r5Cq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa0a3796_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormTelefone_vue__ = __webpack_require__("rrqV");
function injectStyle (ssrContext) {
  __webpack_require__("qJCj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa0a3796"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormTelefone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa0a3796_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormTelefone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GF/y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H4Bk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__ = __webpack_require__("iyFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist',
  components: { Calendario: __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__["a" /* default */] },
  data: function data() {
    return {
      showFilters: false,
      showCalendarMin: false,
      showCalendarMax: false,
      loading: false,
      dthoje: undefined,
      filters: {
        coduser: '*',
        flag: '*',
        situacao: '*',
        dtmin: '1900-01-01 00:00:00',
        dtmax: '9999-12-31 00:00:00'
      },
      tarefas: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/gettarefa.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.length > 0) {
          this.tarefas = response.body;
        } else {
          this.tarefas = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/tarefa/u/' + cod });
    },
    setDateMin: function setDateMin(dt) {
      var aaaa = dt.substring(0, 4);
      var mm = dt.substring(4, 6);
      var dd = dt.substring(6, 8);
      this.filters.dtmin = aaaa + '-' + mm + '-' + dd + ' 00:00:00';
      this.showCalendarMin = false;
      this.$refs.dtmindisplay.value = dd + '/' + mm + '/' + aaaa;
    },
    setDateMax: function setDateMax(dt) {
      var aaaa = dt.substring(0, 4);
      var mm = dt.substring(4, 6);
      var dd = dt.substring(6, 8);
      this.filters.dtmax = aaaa + '-' + mm + '-' + dd + ' 00:00:00';
      this.showCalendarMax = false;
      this.$refs.dtmaxdisplay.value = dd + '/' + mm + '/' + aaaa;
    },
    searchWithFilters: function searchWithFilters() {
      this.load({ 'keyword': this.$route.query.s, 'filters': this.filters });
      console.log('Busca por Filtros...');
    },
    isUrgent: function isUrgent(dtLimite, flag, situacao, index) {
      if (this.dthoje === undefined) this.dthoje = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      var atrasado = dtLimite.slice(0, 10).replace(/-/g, '') < this.dthoje;
      this.tarefas[index].atrasado = atrasado;
      flag = parseInt(flag);
      situacao = parseInt(situacao);
      if (situacao === 6) {
        return 'text-muted';
      } else if (!atrasado) {
        if (flag === 0 && situacao < 6) {
          return 'bg-danger';
        } else if (flag < 3 && situacao < 6) {
          return 'text-warning';
        } else {
          return '';
        }
      } else {
        if (flag === 0) {
          return 'bg-danger text-danger';
        } else if (flag < 3) {
          return 'bg-warning text-danger';
        } else if (flag === 3) {
          return 'text-warning';
        } else {
          return 'text-warning';
        }
      }
    }
  },
  created: function created() {
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_2__Mask_js__["a" /* default */].telefone;
    var keyword = this.$route.query.s;
    this.load({ 'keyword': keyword, 'filters': false });
  },
  watch: {
    '$route': function $route(to, from) {
      var keyword = this.$route.query.s;
      this.load({ 'keyword': keyword, 'filters': false });
    }
  }
});

/***/ }),

/***/ "HG+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManRel_vue__ = __webpack_require__("ZkD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09d11788_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManRel_vue__ = __webpack_require__("HQVf");
function injectStyle (ssrContext) {
  __webpack_require__("BTBH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09d11788"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManRel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09d11788_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManRel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HQVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-12 text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/manuais"}},[_vm._v("Manuais")]),_vm._v(" » "),_c('router-link',{attrs:{"to":"/manual/c/0"}},[_vm._v("Adicionar")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.manuais),function(item,key){return [_c('div',{staticClass:"col-sm-4 text-left"},[_c('div',[_c('h4',[_vm._v(_vm._s(key))]),_vm._v(" "),_vm._l((item),function(m){return [_c('a',{on:{"click":function($event){$event.preventDefault();_vm.select4catsubcat(m.cat,m.subcat)}}},[_vm._v(_vm._s(m.cat)+" » "+_vm._s(m.subcat))]),_c('b',{staticClass:"text-muted"},[_vm._v(" ( "+_vm._s(m.qtd)+" )")]),_c('br')]})],2)])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HVS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  cep: function cep(input) {
    input = input.toString().replace(/\D/g, '');
    var size = input.length;
    if (size < 3) {
      input = input.substring(0, 2);
    } else if (size < 6) {
      input = input.substring(0, 2) + '.' + input.substring(2, 5);
    } else {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '-' + input.substring(5, 8);
    }
    return input;
  },
  cnpj: function cnpj(input) {
    input = input.toString().replace(/\D/g, '');
    var size = input.length;
    if (size < 3) {
      input = input.substring(0, 2);
    } else if (size < 6) {
      input = input.substring(0, 2) + '.' + input.substring(2, size);
    } else if (size < 9) {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '.' + input.substring(5, size);
    } else if (size < 13) {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '.' + input.substring(5, 8) + '/' + input.substring(8, size);
    } else {
      input = input.substring(0, 2) + '.' + input.substring(2, 5) + '.' + input.substring(5, 8) + '/' + input.substring(8, 12) + '.' + input.substring(12, 14);
    }
    return input;
  },
  ie: function ie(input) {
    input = input.toString().replace(/\D/g, '');
    var size = input.length;
    if (size > 3) {
      input = input.substring(0, 3) + '/' + input.substring(3, 11);
    }
    return input;
  },
  monetario: function monetario(input) {
    var forcefive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (input.toString().indexOf('.') === -1) {
      input = input.toString() + '00';
    } else if (input.toString().length - input.toString().indexOf('.') === 2) {
      input = input.toString() + '0';
    }
    input = input.toString().replace(/\D/g, '');
    if (forcefive) {
      var l = input.length;
      if (l < 5) input += '0'.repeat(5 - l);
    }
    input = parseInt(input).toString();
    var size = input.length;
    if (size === 1) {
      input = 'R$ 0,0' + input;
    } else if (size === 2) {
      input = 'R$ 0,' + input;
    } else if (size < 6) {
      input = 'R$ ' + input.substring(0, size - 2) + ',' + input.substring(size - 2, size);
    } else {
      input = 'R$ ' + input.substring(0, size - 5) + '.' + input.substring(size - 5, size - 2) + ',' + input.substring(size - 2, size);
    }
    return input;
  },
  telefone: function telefone(input) {
    input = input.toString().replace(/\D/g, '');
    var size = input.length;
    if (size < 3) {
      input = input.substring(0, 2);
    } else if (size < 7) {
      input = '(' + input.substring(0, 2) + ') ' + input.substring(2, size);
    } else if (size < 11) {
      input = '(' + input.substring(0, 2) + ') ' + input.substring(2, 6) + '-' + input.substring(6, size);
    } else {
      input = '(' + input.substring(0, 2) + ') ' + input.substring(2, 7) + '-' + input.substring(7, 11);
    }
    return input;
  },
  hora: function hora(input) {
    input = input.toString().replace(/\D/g, '');
    var size = input.length;
    if (size >= 3) {
      input = input.substring(0, 2) + ':' + input.substring(2, 4);
    }
    return input;
  }
});

/***/ }),

/***/ "HnWE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IXlI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Itdc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J0Zt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JuAB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K+lu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-default"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('a',{staticClass:"glyphicon glyphicon-menu-hamburger",attrs:{"id":"menu-hamburger"},on:{"click":function($event){$event.preventDefault();_vm.displayMenu()}}}),_vm._v(" HUB")]),_vm._v(" "),_c('li',{staticClass:"pull-right",attrs:{"id":"logout-small"}},[_c('a',{staticClass:"glyphicon glyphicon-user logout",attrs:{"title":"Logout?"},on:{"click":function($event){$event.preventDefault();_vm.logout()}}})])]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav",attrs:{"id":"navmenu"}},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/Agenda"}},[_vm._v("Agenda")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/clientes/sup"}},[_vm._v("Clientes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/clientes/cob/docs"}},[_vm._v("Docs")])],1),_vm._v(" "),(_vm.nivel==='2')?_c('li',[_c('router-link',{attrs:{"to":"/emails"}},[_vm._v("Email")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/manuais"}},[_vm._v("Manuais")])],1),_vm._v(" "),(_vm.nivel==='2')?_c('li',[_c('router-link',{attrs:{"to":"/mensagens"}},[_vm._v("Mensagens")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/pacotes"}},[_vm._v("Pacotes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/tarefas"}},[_vm._v("Tarefas")])],1),_vm._v(" "),(_vm.nivel==='2')?_c('li',[_c('router-link',{attrs:{"to":"/usuarios"}},[_vm._v("Usuarios")])],1):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"smart"},[_c('form',{staticClass:"navbar-form",attrs:{"role":"search"}},[_c('div',{staticClass:"input-group"},[_c('input',{ref:"iptSearchKeyword",staticClass:"form-control",attrs:{"type":"text","placeholder":"Search","name":"q"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.search()}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.search()}}},[_c('i',{staticClass:"glyphicon glyphicon-search"})])])])])]),_vm._v(" "),(_vm.isVisibleMenu)?_c('ul',{staticClass:"nav navbar-nav",attrs:{"id":"navmenusmall"}},[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/Agenda"}},[_vm._v("Agenda")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/clientes/sup"}},[_vm._v("Clientes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/clientes/cob/docs"}},[_vm._v("Docs")])],1),_vm._v(" "),(_vm.nivel==='2')?_c('li',[_c('router-link',{attrs:{"to":"/emails"}},[_vm._v("Email")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/manuais"}},[_vm._v("Manuais")])],1),_vm._v(" "),(_vm.nivel==='2')?_c('li',[_c('router-link',{attrs:{"to":"/mensagens"}},[_vm._v("Mensagens")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/pacotes"}},[_vm._v("Pacotes")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/tarefas"}},[_vm._v("Tarefas")])],1),_vm._v(" "),(_vm.nivel==='2')?_c('li',[_c('router-link',{attrs:{"to":"/usuarios"}},[_vm._v("Usuarios")])],1):_vm._e(),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav pull-right",attrs:{"id":"logout"}},[_c('li',[_c('a',{staticClass:"glyphicon glyphicon-user logout",attrs:{"title":"Logout?"},on:{"click":function($event){$event.preventDefault();_vm.logout()}}})])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('form',{staticClass:"navbar-form",attrs:{"role":"search"}},[_c('div',{staticClass:"input-group"},[_c('input',{ref:"iptSearchKeyword2",staticClass:"form-control",attrs:{"type":"text","placeholder":"Search","name":"q"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.search()}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.search()}}},[_c('i',{staticClass:"glyphicon glyphicon-search"})])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_atualizacoes/?script_case_init=3641&script_case_session=a4af4st5akomnrr0odnnqh7d60","target":"_blank"}},[_vm._v("Psweb Packs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_bancos/?nmgp_outra_jan=true&nmgp_start=SC&script_case_session=l2plpkd0vjake865mfv3gsn2h6&6073","target":"_blank"}},[_vm._v("BDPS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_atualizacoes/?script_case_init=3641&script_case_session=a4af4st5akomnrr0odnnqh7d60","target":"_blank"}},[_vm._v("Psweb Packs")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"http://192.168.1.80:8081/scriptcase/app/PsAdmin/cons_bancos/?nmgp_outra_jan=true&nmgp_start=SC&script_case_session=l2plpkd0vjake865mfv3gsn2h6&6073","target":"_blank"}},[_vm._v("BDPS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KNKV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemForm_vue__ = __webpack_require__("tVHs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3273910_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemForm_vue__ = __webpack_require__("BJz3");
function injectStyle (ssrContext) {
  __webpack_require__("3EzT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3273910"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3273910_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LYXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LlnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Clientes',
  components: {},
  data: function data() {
    return {
      logado: false
    };
  },

  methods: {},
  watch: {
    '$route': function $route(to, from) {
      this.$parent.focusIptSearch();
    }
  },
  created: function created() {
    this.logado = this.$root.auth;
    this.$parent.focusIptSearch();
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f82cf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Mp26");
function injectStyle (ssrContext) {
  __webpack_require__("o//j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f82cf1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MVj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Tarefas',
  data: function data() {
    return {
      logado: false,
      ok: true
    };
  },

  created: function created() {
    this.logado = this.$root.auth;
  }
});

/***/ }),

/***/ "Mp26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$root.auth)?_c('navbarapp',{ref:"cmpNavbar",on:{"logout":function($event){_vm.logout()}}}):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NDeD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarRel_vue__ = __webpack_require__("H4Bk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5757e2dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarRel_vue__ = __webpack_require__("bETM");
function injectStyle (ssrContext) {
  __webpack_require__("JuAB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5757e2dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarRel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5757e2dd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarRel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

// Vue.config.productionTip = false

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  data: function data() {
    return {
      auth: false,
      cod: -1,
      nome: '',
      nivel: -1,
      globalAgeFormDt: undefined
    };
  }
});

/***/ }),

/***/ "Nhny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Mask from './Mask.js'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'emailrel',
  data: function data() {
    return {
      loading: false,
      emails: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getemail.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.emails = response.body.rows;
        } else {
          this.emails = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/email/u/' + cod });
    },
    select4send: function select4send(cod) {
      this.$router.push({ path: '/emails/' + cod });
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    '$route': function $route(to, from) {
      this.load();
    }
  }
});

/***/ }),

/***/ "OHIO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OrLa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormEmail_vue__ = __webpack_require__("h85n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15ce5961_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormEmail_vue__ = __webpack_require__("naUZ");
function injectStyle (ssrContext) {
  __webpack_require__("FU+i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15ce5961"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliFormEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15ce5961_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliFormEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PeDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q0GH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QvX/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RQnU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RUbm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RjTp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mensagemselect',
  data: function data() {
    return {
      loading: false,
      iptSelectBool: false,
      msg: [],
      chaves: [],
      msglist: []
    };
  },

  methods: {
    loadMsg: function loadMsg() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getmsg.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response);
        console.log(response.body);
        if (response.body.cod > 0) {
          this.msg = response.body;
          this.loadMsgList();
        } else {
          console.log('Erro ao carregar a Mensagem.');
        }
      }, function (error) {
        console.log(error);
      });
    },
    loadMsgList: function loadMsgList() {
      var url = './api/php/getmsglist.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'cod': this.msg.cod })).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.chaves = response.body.rows;
        } else {
          this.chaves = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    save: function save() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/addmsglist.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'rows': this.msglist })).then(function (response) {
        console.log(response);
        if (response.body.status) {
          this.chaves = response.body.rows;
        } else {
          this.chaves = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    saveList: function saveList() {
      this.msglist = [];
      var codmsg = this.msg.cod;
      var atucodig = this.msg.atucodig;
      var l = this.chaves.length;
      var chave = '';
      var i = 0;
      for (i; i < l; i++) {
        chave = this.chaves[i];
        if (chave.status) {
          this.msglist.push({ 'codmsg': codmsg, 'cliente': chave.cliente, 'atucodig': atucodig });
        }
      }
      this.save();
    },
    selectAll: function selectAll() {
      var bool = this.$refs.iptselectall.checked;
      this.iptSelectBool = bool;
      var l = this.chaves.length;
      var i = 0;
      for (i; i < l; i++) {
        this.chaves[i].status = bool;
      }
    },
    formatData: function formatData(date) {
      if (date.length > 0) {
        date = date.replace(/-/g, '').substring(0, 8);
        return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4);
      }
    }
  },
  created: function created() {
    var cod = this.$route.params.id;
    this.loadMsg({ 'cod': cod });
  },
  watch: {
    '$route': function $route(to, from) {
      var cod = this.$route.params.id;
      this.loadMsg({ 'cod': cod });
    }
  }
});

/***/ }),

/***/ "RxpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Ferias',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "SIYD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SWow":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SboS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TKn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("dxC/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81d88222_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("SIYD");
function injectStyle (ssrContext) {
  __webpack_require__("/Hd2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81d88222"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81d88222_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tb1r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UBrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_root"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/emails"}},[_vm._v("Email")]),_vm._v(" » "+_vm._s(_vm.crud_action)+"\n      "),(!_vm.loading)?_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Salvar")]):_c('button',{staticClass:"btn btn-muted pull-right"},[_vm._v("Aguarde...")])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Assunto")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.assunto),expression:"form.assunto"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Assunto do Email"},domProps:{"value":(_vm.form.assunto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "assunto", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Destinatários")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tpMailList),expression:"tpMailList"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tpMailList=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Escolher depois")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Pagadores ( Manda 1 email para cada cliente com R$ > 0 )")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Todos ( Manda email para todos os emails cadastrados )")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Corpo do Email")]),_vm._v(" "),_c('wysiwyg',{ref:"conteudo"})],1),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UJ21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UkWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__ = __webpack_require__("Y7kT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    wysiwyg: __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      crud_action: '',
      tpMailList: '0',
      form: {
        cod: 0,
        assunto: '',
        conteudo: ''
      },
      maillist: {
        clientes: [],
        current: 0,
        nrows: 0
      }
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getemail.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        this.fetchData(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    fetchData: function fetchData(o) {
      this.form = o;
      this.$refs.conteudo.setContent(o.conteudo);
    },
    loadClientes: function loadClientes() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.length) {
          this.maillist.clientes = response.body;
          this.maillist.nrows = response.body.length;
          this.addMailList();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Ops!', 'Ocorreu um erro ao adicionar automaticamente os emails. Você pode adicioná-los manualmente depois.', 'error');
        }
      }, function (error) {
        console.log(error);
      });
    },
    save: function save() {
      this.form.conteudo = this.$refs.conteudo.getContent();
      var url = './api/php/addemail.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.form = response.body.form;
          if (response.body.action === 'add') {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Email salvo.', '', 'success');
            if (this.tpMailList === '1') {
              this.loadClientes({ 'cob': true });
            } else if (this.tpMailList === '2') {
              this.loadClientes();
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Email alterado', '', 'success');
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Ocorreu um erro inesperado', response.body.text, 'error');
        }
        this.closeForm();
      }, function (error) {
        console.log(error);
      });
    },
    saveMailList: function saveMailList(form) {
      var url = './api/php/addemaillist.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(form)).then(function (response) {
        if (response.body.status) {
          if (this.maillist.current < this.maillist.nrows) {
            this.addMailList();
          }
        } else {
          console.log(response.body);
        }
      }, function (error) {
        console.log(error);
      });
    },
    addMailList: function addMailList() {
      var raw = this.maillist.clientes[this.maillist.current++];
      var form = {};
      form.email = this.filterMails(raw.email);
      if (form.email) {
        form.codemail = this.form.cod;
        form.codcli = raw.cod;
        this.saveMailList(form);
      } else {
        if (this.maillist.current < this.maillist.nrows) {
          this.addMailList();
        }
      }
    },
    filterMails: function filterMails(emails) {
      if (emails[0] !== undefined && emails[0].endereco.indexOf('@') >= 1) {
        return emails[0].endereco;
      } else {
        return false;
      }
    },
    closeForm: function closeForm() {
      if (this.tpMailList === '1') {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Sucesso', 'Lista configurada com os emails dos PAGADORES', 'success');
      } else if (this.tpMailList === '2') {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Sucesso', 'Lista configurada com os emails de TODOS OS CLIENTES', 'success');
      }
      this.$router.push({ path: '/emails' });
    }
  },
  created: function created() {
    var crud = this.$route.params.crud;
    var cod = this.$route.params.id;
    if (crud === 'c') {
      // Criar novo email
      console.log('Criando novo email');
      this.crud_action = 'Novo';
      // this.form.codautor = this.$root.cod
      this.loadCliente(cod);
    } else if (crud === 'u') {
      // Altera um email
      console.log('Alterando um email');
      this.crud_action = 'Alterando (#' + cod + ')';
      this.load({ 'cod': cod });
    } else {
      console.log('CRUD INVÁLIDO EM FORM EMAIL');
    }
  }
});

/***/ }),

/***/ "VglG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mask_js__ = __webpack_require__("HVS0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'endereco',
  props: ['prefix', 'ender', 'title'],
  data: function data() {
    return {
      no: ''
    };
  },

  methods: {
    add: function add(key, value) {
      this.$emit('insert', this.prefix, key, value);
    },
    maskCepInput: function maskCepInput(e) {
      e.target.value = __WEBPACK_IMPORTED_MODULE_0__Mask_js__["a" /* default */].cep(e.target.value);
    },
    googleLink: function googleLink() {
      var google = 'https://www.google.com.br/maps/place/';
      var endereco = this.ender.rua + ',' + this.ender.numero + '-' + this.ender.bairro + ',' + this.ender.cidade + '-' + this.ender.uf;
      return google + endereco;
    }
  }
});

/***/ }),

/***/ "WB92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_root"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/clientes/cob"}},[_vm._v("Cobrança")]),_vm._v(" » "+_vm._s(_vm.crud_action)+" \n      "),_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.saveForm()}}},[_vm._v("Salvar")]),_vm._v(" "),(_vm.crud_action==='Alterando')?_c('span',{staticClass:"pull-right"},[_c('router-link',{attrs:{"to":'/historico/'+_vm.form.cod}},[_c('i',{staticClass:"glyphicon glyphicon-list",attrs:{"title":"Histórico"}})]),_vm._v(" "),_c('router-link',{attrs:{"to":'/agenda/c/'+_vm.form.cod}},[_c('i',{staticClass:"glyphicon glyphicon-book",attrs:{"title":"Agenda"}})]),_vm._v(" "),_c('router-link',{attrs:{"to":'/tarefa/c/'+_vm.form.cod}},[_c('i',{staticClass:"glyphicon glyphicon-flag",attrs:{"title":"Tarefas"}})]),_vm._v(" \n      ")],1):_vm._e()],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Cód.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cod),expression:"form.cod"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"cod"},domProps:{"value":(_vm.form.cod)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cod", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Chave Cliente")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.chavecliente),expression:"form.chavecliente"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Chave CLIENTE pos.16"},domProps:{"value":(_vm.form.chavecliente)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "chavecliente", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Grupo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.grupo),expression:"form.grupo"}],staticClass:"form-control up",attrs:{"type":"text","placeholder":"Grupo / Chave cliente"},domProps:{"value":(_vm.form.grupo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "grupo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Situação")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.situacao),expression:"form.situacao"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"4"}},[_vm._v("Ativo")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Ativo - PS Antigo")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Bloqueado - Não Paga!")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Excluído - Mudou Razão")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Excluído")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Razão Social")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.razao),expression:"form.razao"}],staticClass:"form-control up",attrs:{"type":"text","placeholder":"razao"},domProps:{"value":(_vm.form.razao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "razao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("CNPJ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cnpj),expression:"form.cnpj"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"xx.xxx.xxx/xxxx.xx","maxlength":"18"},domProps:{"value":(_vm.form.cnpj)},on:{"keydown":function($event){_vm.maskCnpjInput($event)},"keyup":function($event){_vm.maskCnpjInput($event)},"change":function($event){_vm.maskCnpjInput($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cnpj", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Insc. Estadual")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ie),expression:"form.ie"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"xxx/xxxxxxx","maxlength":"11"},domProps:{"value":(_vm.form.ie)},on:{"keydown":function($event){_vm.maskIeInput($event)},"keyup":function($event){_vm.maskIeInput($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "ie", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-5"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Fantasia")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.fantasia),expression:"form.fantasia"}],staticClass:"form-control up",attrs:{"type":"text","placeholder":"Fantasia"},domProps:{"value":(_vm.form.fantasia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "fantasia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Vcto.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cobdia),expression:"form.cobdia"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Dia"},domProps:{"value":(_vm.form.cobdia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cobdia", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label",attrs:{"for":"ipt_cod"}},[_vm._v("Valor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cobvalor),expression:"form.cobvalor"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"R$ Use PONTO"},domProps:{"value":(_vm.form.cobvalor)},on:{"focusout":function($event){_vm.maskMonetarioInput($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cobvalor", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.recebenfse),expression:"form.recebenfse"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.recebenfse)?_vm._i(_vm.form.recebenfse,null)>-1:(_vm.form.recebenfse)},on:{"change":function($event){var $$a=_vm.form.recebenfse,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.recebenfse=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.recebenfse=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "recebenfse", $$c)}}}}),_c('label',{staticClass:"control-label"},[_vm._v("NFSe")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.emailnfse),expression:"form.emailnfse"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.emailnfse)?_vm._i(_vm.form.emailnfse,null)>-1:(_vm.form.emailnfse)},on:{"change":function($event){var $$a=_vm.form.emailnfse,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.emailnfse=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.emailnfse=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "emailnfse", $$c)}}}}),_c('label',{staticClass:"control-label"},[_vm._v("NFSe por email")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.emailboleto),expression:"form.emailboleto"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.emailboleto)?_vm._i(_vm.form.emailboleto,null)>-1:(_vm.form.emailboleto)},on:{"change":function($event){var $$a=_vm.form.emailboleto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.emailboleto=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.emailboleto=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "emailboleto", $$c)}}}}),_c('label',{staticClass:"control-label"},[_vm._v("Boleto por email")])]),_vm._v(" "),_c('endereco',{attrs:{"prefix":"cob","ender":_vm.form.cob,"title":"de Cobrança"}}),_vm._v(" "),_c('endereco',{attrs:{"prefix":"end","ender":_vm.form.end,"title":"da Empresa"}}),_vm._v(" "),_c('telefones',{attrs:{"telefones":_vm.form.telefone},on:{"add":_vm.addItem,"remove":_vm.removeItem}}),_vm._v(" "),_c('emails',{attrs:{"emails":_vm.form.email},on:{"add":_vm.addItem,"remove":_vm.removeItem}}),_vm._v(" "),_c('acessos',{attrs:{"acessos":_vm.form.acesso},on:{"add":_vm.addItem,"remove":_vm.removeItem}}),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',{staticClass:"control-label",attrs:{"for":"psweb"}},[_vm._v("Endereço PSWeb Externo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.psweblink),expression:"form.psweblink"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"ex: http://ps2000.ddns.com.br:8081/psweb/"},domProps:{"value":(_vm.form.psweblink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "psweblink", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Sistema Operacional")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.uso),expression:"form.uso"}],staticClass:"form-control",attrs:{"name":"so","id":"","placeholder":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "uso", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"windows"},domProps:{"selected":_vm.form.unfe==='windows'}},[_vm._v("Windows")]),_vm._v(" "),_c('option',{attrs:{"value":"linux"},domProps:{"selected":_vm.form.unfe==='linux'}},[_vm._v("Linux")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("NFe")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.unfe),expression:"form.unfe"}],staticClass:"form-control",attrs:{"name":"nfe","id":"","placeholder":"NFe"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "unfe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.form.unfe==='0'}},[_vm._v("Não usa")]),_vm._v(" "),_c('option',{attrs:{"value":"nfe+"},domProps:{"selected":_vm.form.unfe==='nfe+'}},[_vm._v("NFE - PsWeb SOAP")]),_vm._v(" "),_c('option',{attrs:{"value":"nfe"},domProps:{"selected":_vm.form.unfe==='nfe'}},[_vm._v("NFE - PsWeb")]),_vm._v(" "),_c('option',{attrs:{"value":"-nfe"},domProps:{"selected":_vm.form.unfe==='-nfe'}},[_vm._v("NFE - Ps2000")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Cupom Fiscal")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ucfe),expression:"form.ucfe"}],staticClass:"form-control",attrs:{"name":"cfe","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "ucfe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.form.ucfe==='0'}},[_vm._v("Não usa")]),_vm._v(" "),_c('option',{attrs:{"value":"cfe+"},domProps:{"selected":_vm.form.ucfe==='cfe+'}},[_vm._v("NFCe - PsWeb Windows")]),_vm._v(" "),_c('option',{attrs:{"value":"cfe"},domProps:{"selected":_vm.form.ucfe==='cfe'}},[_vm._v("NFCe - PsWeb Acbr")]),_vm._v(" "),_c('option',{attrs:{"value":"cf"},domProps:{"selected":_vm.form.ucfe==='cf'}},[_vm._v("CF - PsWeb")]),_vm._v(" "),_c('option',{attrs:{"value":"-cf"},domProps:{"selected":_vm.form.ucfe==='-cf'}},[_vm._v("CF - Ps2000")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Nota de Serviço")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.unfse),expression:"form.unfse"}],staticClass:"form-control",attrs:{"name":"nfse","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "unfse", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.form.unfse==='0'}},[_vm._v("Não usa")]),_vm._v(" "),_c('option',{attrs:{"value":"nfse"},domProps:{"selected":_vm.form.unfse==='nfse'}},[_vm._v("NFSe - PsWeb")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("MDFe")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.umdfe),expression:"form.umdfe"}],staticClass:"form-control",attrs:{"name":"mdfe","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "umdfe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.form.umdfe==='0'}},[_vm._v("Não usa")]),_vm._v(" "),_c('option',{attrs:{"value":"mdfe"},domProps:{"selected":_vm.form.umdfe==='mdfe'}},[_vm._v("MDFe - PsWeb")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("CTe")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.ucte),expression:"form.ucte"}],staticClass:"form-control",attrs:{"name":"cte","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "ucte", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.form.ucte==='0'}},[_vm._v("Não usa")]),_vm._v(" "),_c('option',{attrs:{"value":"cte"},domProps:{"selected":_vm.form.ucte==='cte'}},[_vm._v("CTe - PsWeb")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Certificado")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.certificado),expression:"form.certificado"}],staticClass:"form-control",attrs:{"name":"certificado","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "certificado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A1"},domProps:{"selected":_vm.form.certificado==='A1'}},[_vm._v("A1 - Arquivo")]),_vm._v(" "),_c('option',{attrs:{"value":"A2"},domProps:{"selected":_vm.form.certificado==='A2'}},[_vm._v("A2 - Token")]),_vm._v(" "),_c('option',{attrs:{"value":"A3"},domProps:{"selected":_vm.form.certificado==='A3'}},[_vm._v("A3 - Cartão")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Etiqueta")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.uetiq),expression:"form.uetiq"}],staticClass:"form-control",attrs:{"name":"etiq","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "uetiq", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.form.uetiq==='0'}},[_vm._v("Não usa")]),_vm._v(" "),_c('option',{attrs:{"value":"etiq"},domProps:{"selected":_vm.form.uetiq==='etiq'}},[_vm._v("PsWeb")]),_vm._v(" "),_c('option',{attrs:{"value":"-etiq"},domProps:{"selected":_vm.form.uetiq==='-etiq'}},[_vm._v("Ps2000")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Remessa")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.uremessa),expression:"form.uremessa"}],staticClass:"form-control",attrs:{"name":"remessa","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "uremessa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.form.uremessa==='0'}},[_vm._v("Não usa")]),_vm._v(" "),_c('option',{attrs:{"value":"remessa"},domProps:{"selected":_vm.form.uremessa==='remessa'}},[_vm._v("PsWeb")]),_vm._v(" "),_c('option',{attrs:{"value":"-remessa"},domProps:{"selected":_vm.form.uremessa==='-remessa'}},[_vm._v("Ps2000")])])])]),_vm._v(" "),_c('div',{staticClass:"text-left col-sm-12"},[_c('hr'),_vm._v(" "),_c('h3',[_c('router-link',{attrs:{"to":"/clientes/cob"}},[_vm._v("Cobrança")]),_vm._v(" » "+_vm._s(_vm.crud_action)+"\n        "),_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.saveForm()}}},[_vm._v("Salvar")]),_vm._v(" "),(_vm.form.cod)?_c('button',{staticClass:"btn btn-danger pull-right",on:{"click":function($event){_vm.remove()}}},[_vm._v("Excluir")]):_vm._e()],1),_vm._v(" "),_c('br'),_c('br'),_c('br')])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colsm-12"},[_c('label',{attrs:{"for":""}},[_vm._v("Uso do Sistema")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WGAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarRelHistory_vue__ = __webpack_require__("yfo1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e485b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarRelHistory_vue__ = __webpack_require__("npPt");
function injectStyle (ssrContext) {
  __webpack_require__("HnWE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43e485b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarRelHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e485b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarRelHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WZfA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XU/M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y/WT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgeRelWeek_vue__ = __webpack_require__("yLTB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75882652_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgeRelWeek_vue__ = __webpack_require__("pUW3");
function injectStyle (ssrContext) {
  __webpack_require__("CKsO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75882652"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgeRelWeek_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75882652_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgeRelWeek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y7kT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wysiwyg_vue__ = __webpack_require__("fDFS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d35698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wysiwyg_vue__ = __webpack_require__("+950");
function injectStyle (ssrContext) {
  __webpack_require__("WZfA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17d35698"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wysiwyg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17d35698_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wysiwyg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YT0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JSCalendar_js__ = __webpack_require__("cr+Z");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'calendar',
  data: function data() {
    return {
      state: 'Day',
      nowDate: {
        d: undefined,
        m: undefined,
        y: undefined
      },
      oDate: {
        m: 9,
        y: 2017
      },
      month: []
    };
  },

  methods: {
    getDate: function getDate() {
      var now = new Date();
      this.nowDate.d = now.getDate();
      this.nowDate.m = now.getMonth();
      this.nowDate.y = now.getFullYear();
      this.oDate.m = now.getMonth();
      this.oDate.y = now.getFullYear();
    },
    setMonth: function setMonth() {
      this.month = this.monthSixWeek(this.oDate.m, this.oDate.y);
    },
    prevMonth: function prevMonth() {
      this.oDate.m -= 1;
      if (this.oDate.m < 0) {
        this.oDate.m = 11;
        this.oDate.y -= 1;
      }
      this.setMonth();
    },
    nextMonth: function nextMonth() {
      this.oDate.m += 1;
      if (this.oDate.m > 11) {
        this.oDate.m = 0;
        this.oDate.y += 1;
      }
      this.setMonth();
    },
    selectMonth: function selectMonth(n) {
      this.oDate.m = n;
      this.setMonth();
      this.state = 'Day';
    },
    monthName: function monthName(n) {
      var names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
      return names[n];
    },
    pickDate: function pickDate(date, week) {
      var w = this.month[week];
      this.$emit('pickDate', date);
      this.$emit('pickWeek', w[0].yyyymmdd, w[6].yyyymmdd, w);
    }
  },
  created: function created() {
    this.monthLastDay = __WEBPACK_IMPORTED_MODULE_0__JSCalendar_js__["a" /* default */].monthLastDay;
    this.monthArrDays = __WEBPACK_IMPORTED_MODULE_0__JSCalendar_js__["a" /* default */].monthArrDays;
    this.monthSixWeek = __WEBPACK_IMPORTED_MODULE_0__JSCalendar_js__["a" /* default */].monthSixWeek;
    this.validMonth = __WEBPACK_IMPORTED_MODULE_0__JSCalendar_js__["a" /* default */].validMonth;
    this.formatMonth = __WEBPACK_IMPORTED_MODULE_0__JSCalendar_js__["a" /* default */].formatMonth;
    this.getDate();
    this.setMonth(this.oDate.m, this.oDate.y);
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Agenda__ = __webpack_require__("gZDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AgeForm__ = __webpack_require__("BM48");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AgeRelWeek__ = __webpack_require__("Y/WT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Clientes__ = __webpack_require__("dRRj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_CliForm__ = __webpack_require__("pjwG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_CliRelCob__ = __webpack_require__("nW8a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_CliRelCobDocs__ = __webpack_require__("sh+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_CliRelCobGrupo__ = __webpack_require__("aLz4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_CliRelSup__ = __webpack_require__("cDkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Email__ = __webpack_require__("6Aj3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_EmailForm__ = __webpack_require__("cVT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_EmailRel__ = __webpack_require__("kISe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_EmailRelSend__ = __webpack_require__("9JAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Ferias__ = __webpack_require__("uBZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_FerRel__ = __webpack_require__("6qAD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Manuais__ = __webpack_require__("4HYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ManForm__ = __webpack_require__("0vvI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ManRel__ = __webpack_require__("HG+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_ManRelCat__ = __webpack_require__("ZH79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Mensagem__ = __webpack_require__("9yT+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_MensagemForm__ = __webpack_require__("KNKV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_MensagemRel__ = __webpack_require__("rae0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_MensagemSelect__ = __webpack_require__("deti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Pacote__ = __webpack_require__("k+IU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_PackRel__ = __webpack_require__("rjS2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Tarefas__ = __webpack_require__("ZqgE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_TarForm__ = __webpack_require__("h9BO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_TarRel__ = __webpack_require__("NDeD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_TarRelHistory__ = __webpack_require__("WGAd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Users__ = __webpack_require__("TKn+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_UserRel__ = __webpack_require__("2MWw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_UserForm__ = __webpack_require__("8iUb");





































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Home__["a" /* default */]
  }, {
    path: '/agenda/:crud/:id',
    name: 'AgendaForm',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Agenda__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_4__components_AgeForm__["a" /* default */]
    }]
  }, {
    path: '/agenda',
    name: 'Agenda',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Agenda__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_5__components_AgeRelWeek__["a" /* default */]
    }]
  }, {
    path: '/cliente/:id',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Clientes__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_7__components_CliForm__["a" /* default */]
    }]
  }, {
    path: '/cliente/:grupo/:id',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Clientes__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_7__components_CliForm__["a" /* default */]
    }]
  }, {
    path: '/clientes/cob/docs',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Clientes__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_9__components_CliRelCobDocs__["a" /* default */]
    }]
  }, {
    path: '/clientes/cob/:grupo',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Clientes__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_10__components_CliRelCobGrupo__["a" /* default */]
    }]
  }, {
    path: '/clientes/cob',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Clientes__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_8__components_CliRelCob__["a" /* default */]
    }]
  }, {
    path: '/clientes/sup',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Clientes__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_11__components_CliRelSup__["a" /* default */]
    }]
  }, {
    path: '/email/:crud/:id',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Email__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_13__components_EmailForm__["a" /* default */]
    }]
  }, {
    path: '/emails/:id',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Email__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_15__components_EmailRelSend__["a" /* default */]
    }]
  }, {
    path: '/emails',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Email__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_14__components_EmailRel__["a" /* default */]
    }]
  }, {
    path: '/manual/:crud/:id',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Manuais__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_20__components_ManForm__["a" /* default */]
    }]
  }, {
    path: '/manuais/:cat',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Manuais__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_22__components_ManRelCat__["a" /* default */]
    }]
  }, {
    path: '/manuais',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Manuais__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_21__components_ManRel__["a" /* default */]
    }]
  }, {
    path: '/mensagens/:id',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Mensagem__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_26__components_MensagemSelect__["a" /* default */]
    }]
  }, {
    path: '/mensagens',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Mensagem__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_25__components_MensagemRel__["a" /* default */]
    }]
  }, {
    path: '/mensagem/:crud/:id',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Mensagem__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_24__components_MensagemForm__["a" /* default */]
    }]
  }, {
    path: '/pacotes/:id',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Pacote__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_28__components_PackRel__["a" /* default */]
    }]
  }, {
    path: '/pacotes',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Pacote__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_28__components_PackRel__["a" /* default */]
    }]
  }, {
    path: '/tarefa/:crud/:id',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Tarefas__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_30__components_TarForm__["a" /* default */]
    }]
  }, {
    path: '/tarefas',
    name: 'Tarefas',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Tarefas__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_31__components_TarRel__["a" /* default */]
    }]
  }, {
    path: '/historico/:id',
    name: 'Historico',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Tarefas__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_32__components_TarRelHistory__["a" /* default */]
    }]
  }, {
    path: '/historico',
    name: 'Historico',
    component: __WEBPACK_IMPORTED_MODULE_29__components_Tarefas__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_32__components_TarRelHistory__["a" /* default */]
    }]
  }, {
    path: '/usuarios',
    component: __WEBPACK_IMPORTED_MODULE_33__components_Users__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_34__components_UserRel__["a" /* default */]
    }]
  }, {
    path: '/usuario/:id',
    component: __WEBPACK_IMPORTED_MODULE_33__components_Users__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_35__components_UserForm__["a" /* default */]
    }]
  }, {
    path: '/ferias',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Ferias__["a" /* default */],
    children: [{
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_17__components_FerRel__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ "YdJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__ = __webpack_require__("Y7kT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    wysiwyg: __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      crud_action: '',
      form: {
        cod: 0,
        cat: '',
        subcat: '',
        titulo: '',
        manual: '',
        tags: '',
        dt_insert: '',
        excluido: 'f'
      }
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getmanual.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        this.fetchData(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    fetchData: function fetchData(o) {
      this.form = o;
      this.$refs.manual.setContent(o.manual);
    },
    save: function save() {
      this.form.manual = this.$refs.manual.getContent();
      var url = './api/php/addmanual.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()('Manual Cadastrado', '', 'success');
        }
        this.closeForm();
      }, function (error) {
        console.log(error);
      });
    },
    closeForm: function closeForm() {
      this.$router.push({ path: '/manuais' });
    }
  },
  created: function created() {
    var crud = this.$route.params.crud;
    var cod = this.$route.params.id;
    if (crud === 'c') {
      // Cria novo Manual
      console.log('Criando novo manual');
      this.crud_action = 'Novo';
    } else if (crud === 'u') {
      // Altera um Manual
      console.log('Alterando um email');
      this.crud_action = 'Alterando (#' + cod + ')';
      this.load({ 'cod': cod });
    } else {
      console.log('CRUD INVÁLIDO EM FORM MANUAL');
    }
  }
});

/***/ }),

/***/ "Yyhu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-12 text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/mensagens"}},[_vm._v("Mensagens")]),_vm._v(" » "),_c('router-link',{attrs:{"to":"/mensagem/c/0"}},[_vm._v("Adicionar")])],1)]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.mensagens),function(msg){return _c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(msg.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-list",attrs:{"title":"Selecionar clientes"},on:{"click":function($event){$event.preventDefault();_vm.select4list(msg.cod)}}})]),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(msg.msg)}}),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(msg.dt_fim))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(msg.qtd))])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("#")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("mensagem")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("validade")]),_vm._v(" "),_c('td',[_vm._v("Qtd.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZH79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManRelCat_vue__ = __webpack_require__("gRhM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3adb744_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManRelCat_vue__ = __webpack_require__("0txO");
function injectStyle (ssrContext) {
  __webpack_require__("qSPT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3adb744"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManRelCat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3adb744_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManRelCat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZSsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_root"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/tarefas"}},[_vm._v("Tarefas")]),_vm._v(" » "+_vm._s(_vm.crud_action)+"\n      "),(!_vm.loading)?_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.save()}}},[_vm._v("Salvar")]):_c('button',{staticClass:"btn btn-muted pull-right"},[_vm._v("Aguarde...")])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Cliente")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.cliente.razao))]),_vm._v(" "),_c('cite',[_vm._v(_vm._s(_vm.cliente.endereco))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.cliente.telefone),function(telefone){return [_c('div',{staticClass:"form-group col-sm-2"},[_c('b',[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero)))]),_c('br'),_c('small',[_vm._v(_vm._s(telefone.descricao.substring(0,20) + '...'))])])]})],2),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Onde?")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.codlocal),expression:"form.codlocal"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "codlocal", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"15"}},[_vm._v("PsWeb » Outro")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("CTE » Autorização")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("MDFE » Autorização")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("MDFE » Digitação")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("NFCE » Autorização")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("NFE » Autorização")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("NFSE » Autorização")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("NFSE » Digitação")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Not.Entrada » Digitação")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Not.Entrada » Fechamento")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Not.Entrada » XML")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Ped.Venda » Digitação")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Ped.Venda » Fechamento")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Relatórios")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("Remessa")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("Impressões")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("Ps2000 » Outro")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo de tarefa")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tipo),expression:"form.tipo"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Atualizar")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Backup do cliente")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Bug / Investigar")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Certificado Digital")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Configurar")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Desenvolver")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Duvidas e Treinamento")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Erro NFE")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Impressora")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Instalar Sistema")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Ligar")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Mandar Boleto")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Pacote Atualização")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Remessa Bancária")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Urgência")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.flag),expression:"form.flag"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "flag", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Imediato")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Urgente")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Moderada")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Normal")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Quando possível")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Quando visitar")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Não Pode Atualizar")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Responsável")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.codresponsavel),expression:"form.codresponsavel"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "codresponsavel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Alguem")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Fabio")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Felipe")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Jair")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Josue")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Lucas")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Prado")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Regis")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Roberto")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Rodrigo")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Sanguine")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Valni")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Data Máxima")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{ref:"dtlimitedisplay",staticClass:"form-control",attrs:{"value":"","type":"text","disabled":""}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendar=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]),_vm._v(" "),(_vm.showCalendar)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDate}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Situação")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.situacao),expression:"form.situacao"}],staticClass:"form-control",attrs:{"id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Aberto")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Re-Aberto")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Devendo retorno...")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Aguardando análise...")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Aguardando desenv...")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Aguardando retorno...")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Resolvido")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Não Pode Atualizar")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Resumo da Situação")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.descr),expression:"form.descr"}],staticClass:"form-control",attrs:{"type":"text","max-length":"255","placeholder":"Máx 255 caracteres"},domProps:{"value":(_vm.form.descr)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "descr", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Situação")]),_vm._v(" "),_c('wysiwyg',{ref:"descricao"})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Soluçao")]),_vm._v(" "),_c('wysiwyg',{ref:"solucao"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZkD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manuallist',
  data: function data() {
    return {
      loading: false,
      manuais: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getmanual.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.manuais = response.body.rows;
        } else {
          this.manuais = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/manual/u/' + cod });
    },
    select4catsubcat: function select4catsubcat(cat, subcat) {
      this.$router.push({ path: '/manuais/categoria', query: { c: cat, sc: subcat } });
    }
  },
  created: function created() {
    this.load();
  },
  watch: {
    '$route': function $route(to, from) {
      this.load();
    }
  }
});

/***/ }),

/***/ "ZqgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tarefas_vue__ = __webpack_require__("MVj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f275adf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tarefas_vue__ = __webpack_require__("sYB9");
function injectStyle (ssrContext) {
  __webpack_require__("cB5l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f275adf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tarefas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f275adf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tarefas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aLz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelCobGrupo_vue__ = __webpack_require__("oR8k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378f6e35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelCobGrupo_vue__ = __webpack_require__("yg3c");
function injectStyle (ssrContext) {
  __webpack_require__("RQnU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-378f6e35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelCobGrupo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_378f6e35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelCobGrupo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aYBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/usuarios"}},[_vm._v("Usuários")]),_vm._v(" » "),_c('router-link',{attrs:{"to":"/usuario/0"}},[_vm._v("Adicionar")])],1)]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.users),function(user){return _c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(user.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-book",attrs:{"title":"Agenda"},on:{"click":function($event){$event.preventDefault();_vm.select4agenda(user.cod)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.nome))])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("nome")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "axs+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b5w2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist',
  data: function data() {
    return {
      loading: false,
      clientes: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.length > 0) {
          this.clientes = response.body;
        } else {
          this.clientes = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/cliente/' + cod });
    },
    select4grupo: function select4grupo(grupo) {
      this.$router.push({ path: '/clientes/cob/' + grupo });
    },
    select4historico: function select4historico(cod) {
      this.$router.push({ path: '/historico/' + cod });
    },
    select4agenda: function select4agenda(cod) {
      this.$router.push({ path: '/agenda/c/' + cod });
    },
    select4tarefa: function select4tarefa(cod) {
      this.$router.push({ path: '/tarefa/c/' + cod });
    },
    useIt: function useIt(input) {
      if (input !== '0') {
        var classe = 'label label-primary';
        if (input[0] === '-') {
          classe = 'label label-danger';
        }
        return '<span class=\'' + classe + '\'>' + input + '</span>';
      }
    }
  },
  created: function created() {
    this.maskCnpj = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].cnpj;
    this.maskMonetario = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].monetario;
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].telefone;
    var keyword = this.$route.query.s;
    this.load({ 'keyword': keyword });
  },
  watch: {
    '$route': function $route(to, from) {
      var keyword = this.$route.query.s;
      this.load({ 'keyword': keyword });
    }
  }
});

/***/ }),

/***/ "bETM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/tarefas"}},[_vm._v("Tarefas")])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.tarefas.length)+" resultado(s) encontrados")]),_vm._v(" "),(this.$route.query.s)?_c('small',[_vm._v(" que contém '"+_vm._s(this.$route.query.s)+"'")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"text-left row"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v("Filtros\n        "),(!_vm.showFilters)?_c('a',{staticClass:"glyphicon glyphicon-eye-open",on:{"click":function($event){$event.preventDefault();_vm.showFilters=true}}}):_vm._e(),_vm._v(" "),(_vm.showFilters)?_c('a',{staticClass:"glyphicon glyphicon-eye-close",on:{"click":function($event){$event.preventDefault();_vm.showFilters=false}}}):_vm._e()])]),_vm._v(" "),(_vm.showFilters)?[_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Responsável")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.coduser),expression:"filters.coduser"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "coduser", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Alguem (Todos)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Fabio")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Felipe")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Jair")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Josue")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Lucas")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Prado")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Regis")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Roberto")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Rodrigo")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Sanguine")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Valni")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Urgência")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.flag),expression:"filters.flag"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "flag", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Imediato")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Urgente")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Moderada")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Normal")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Quando possível")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Situação")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.situacao),expression:"filters.situacao"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Abertos")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Abertos e Aguardando")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Aguardando")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Resolvido")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Data Minima")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{ref:"dtmindisplay",staticClass:"form-control",attrs:{"value":"01/01/1900","type":"text","disabled":""}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendarMin=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]),_vm._v(" "),(_vm.showCalendarMin)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDateMin}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Data Máxima")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{ref:"dtmaxdisplay",staticClass:"form-control",attrs:{"value":"31/12/9999","type":"text","disabled":""}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendarMax=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]),_vm._v(" "),(_vm.showCalendarMax)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDateMax}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',[_vm._v("Aplicar filtro")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.searchWithFilters()}}},[_vm._v("Pesquisar")])])]:_vm._e()],2),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.tarefas),function(tarefa,index){return _c('tr',{class:_vm.isUrgent(tarefa.dt_limite, tarefa.flag, tarefa.situacao, index)},[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(tarefa.cod)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(tarefa.razao)),_c('br'),_c('small',[_vm._v(_vm._s(tarefa.fantasia))])]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(tarefa.descr)),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(tarefa.autornome)+" » "+_vm._s(tarefa.responsavelnome))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(tarefa.dt_limite)),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(tarefa.flagdescr))])]),_vm._v(" "),_c('td',_vm._l((tarefa.telefone),function(telefone){return _c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero))),_c('br')])})),_vm._v(" "),_c('td',{staticClass:"text-center"},[(tarefa.atrasado && tarefa.situacao !== '6')?_c('b',[_vm._v("(PRAZO!)"),_c('br')]):_vm._e(),_vm._v("\n        "+_vm._s(tarefa.situacaodescr)),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(tarefa.solucionadornome))])])])})],2),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v("razao")]),_vm._v(" "),_c('td',[_vm._v("descrição")]),_vm._v(" "),_c('td',[_vm._v("prazo")]),_vm._v(" "),_c('td',[_vm._v("contato")]),_vm._v(" "),_c('td',[_vm._v("situação")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bOZH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bjgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/agenda"}},[_vm._v("Agenda")]),_vm._v(" » "+_vm._s(_vm.crud === 'c'? 'Novo' : 'Alterando')+"\n      ")],1)]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('h3',[_vm._v(_vm._s(_vm.cliente.razao))]),_vm._v(" "),_c('span',{staticClass:"label label-default"},[_vm._v(_vm._s(_vm.cliente.fantasia))]),_c('br'),_vm._v(" "),_c('cite',[_vm._v(_vm._s(_vm.cliente.endereco))]),_c('br'),_vm._v(" "),_vm._l((_vm.cliente.telefone),function(telefone){return _c('span',[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero)))])}),_vm._v(" "),_c('hr',{attrs:{"size":"2"}}),_vm._v(" "),_c('div',{staticClass:"form"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Data")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.formatData(_vm.form.dt)}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn spancelendar"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendar=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})])]),_vm._v(" "),(_vm.showCalendar)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDate}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Hora")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.hora),expression:"form.hora"}],staticClass:"form-control slim",attrs:{"type":"text","placeholder":"08:00","max-length":"5"},domProps:{"value":(_vm.form.hora)},on:{"focusout":function($event){_vm.maskHora($event)},"keyup":function($event){_vm.maskHora($event)},"keydown":function($event){_vm.maskHora($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "hora", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('label',{attrs:{"for":""}},[_vm._v("Funcionário")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.codfuncionario),expression:"form.codfuncionario"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "codfuncionario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.form.codfuncionario==='1'}},[_vm._v("Alguem")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.form.codfuncionario==='2'}},[_vm._v("Fabio")]),_vm._v(" "),_c('option',{attrs:{"value":"3"},domProps:{"selected":_vm.form.codfuncionario==='3'}},[_vm._v("Felipe")]),_vm._v(" "),_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.form.codfuncionario==='4'}},[_vm._v("Jair")]),_vm._v(" "),_c('option',{attrs:{"value":"5"},domProps:{"selected":_vm.form.codfuncionario==='5'}},[_vm._v("Josue")]),_vm._v(" "),_c('option',{attrs:{"value":"6"},domProps:{"selected":_vm.form.codfuncionario==='6'}},[_vm._v("Lucas")]),_vm._v(" "),_c('option',{attrs:{"value":"7"},domProps:{"selected":_vm.form.codfuncionario==='7'}},[_vm._v("Prado")]),_vm._v(" "),_c('option',{attrs:{"value":"8"},domProps:{"selected":_vm.form.codfuncionario==='8'}},[_vm._v("Regis")]),_vm._v(" "),_c('option',{attrs:{"value":"9"},domProps:{"selected":_vm.form.codfuncionario==='9'}},[_vm._v("Roberto")]),_vm._v(" "),_c('option',{attrs:{"value":"10"},domProps:{"selected":_vm.form.codfuncionario==='10'}},[_vm._v("Rodrigo")]),_vm._v(" "),_c('option',{attrs:{"value":"11"},domProps:{"selected":_vm.form.codfuncionario==='11'}},[_vm._v("Sanguine")]),_vm._v(" "),_c('option',{attrs:{"value":"12"},domProps:{"selected":_vm.form.codfuncionario==='12'}},[_vm._v("Valni")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.descricao),expression:"form.descricao"}],ref:"iptdescricao",staticClass:"form-control",attrs:{"name":"","id":"","cols":"30","rows":"10"},domProps:{"value":(_vm.form.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-left"},[(_vm.form.cod)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.remove()}}},[_vm._v("Excluir Compromisso")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){_vm.save()}}},[_vm._v("Salvar Compromisso")])])])],2)]),_vm._v(" "),(_vm.form.dt)?_c('div',{staticClass:"col-sm-6 text-left"},[_c('h3',[_vm._v("Compromissos para "+_vm._s(_vm.formatData(_vm.form.dt)))]),_vm._v(" "),_vm._l((_vm.compromissos[_vm.form.dt]),function(compromisso){return _c('div',[_c('b',[_vm._v(_vm._s(compromisso.hora))]),_vm._v(" "),_c('cite',[_vm._v(_vm._s(compromisso.razao))]),_vm._v(" ("+_vm._s(compromisso.funcionarionome)+")"),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(compromisso.descricao))]),_vm._v(" "),_c('hr')])})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "byFV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Manuais',
  components: {},
  data: function data() {
    return {
      logado: false
    };
  },

  methods: {},
  created: function created() {
    this.logado = this.$root.auth;
  }
});

/***/ }),

/***/ "cB5l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cDkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelSup_vue__ = __webpack_require__("b5w2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2181c31c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelSup_vue__ = __webpack_require__("dnRr");
function injectStyle (ssrContext) {
  __webpack_require__("ifB2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2181c31c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelSup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2181c31c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelSup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cVT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailForm_vue__ = __webpack_require__("UkWO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ff5d832_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailForm_vue__ = __webpack_require__("UBrn");
function injectStyle (ssrContext) {
  __webpack_require__("SboS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ff5d832"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ff5d832_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cr+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  monthLastDay: function monthLastDay() {
    var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return new Date(y, m, 0);
  },
  monthArrDays: function monthArrDays() {
    var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var now = new Date();
    var prevLastDay = this.monthLastDay(m, y);
    var pN = prevLastDay.getDate();
    var pS = prevLastDay.getDay();
    var currLastDay = this.monthLastDay(m + 1, y);
    var cN = currLastDay.getDate();
    var swm = [];
    m = this.formatMonth(prevLastDay.getMonth());
    y = prevLastDay.getFullYear();
    var s = 0;
    for (var i = pN - pS; i <= pN; i++) {
      swm.push({ 'd': i, 'm': m, 'y': y, 's': s++, 'yyyymmdd': y + '' + m + '' + (i > 9 ? '' : '0') + i, status: 'out' });
      if (s > 6) s = 0;
    }
    var nowMonth = this.formatMonth(now.getMonth());
    m = this.formatMonth(m);
    y = currLastDay.getFullYear();
    for (var _i = 1; _i <= cN; _i++) {
      var status = m !== nowMonth ? '' : y !== now.getFullYear() ? '' : _i !== now.getDate() ? '' : 'now';
      swm.push({ 'd': _i, 'm': m, 'y': y, 's': s++, 'yyyymmdd': y + '' + m + '' + (_i > 9 ? '' : '0') + _i, 'status': status });
      if (s > 6) s = 0;
    }
    var sufixDaysCount = 42 - swm.length;
    m = this.formatMonth(currLastDay.getMonth(m) + 1);
    if (m === '01') y += 1;
    for (var _i2 = 1; _i2 <= sufixDaysCount; _i2++) {
      swm.push({ 'd': _i2, 'm': m, 'y': y, 's': s++, 'yyyymmdd': y + '' + m + '' + (_i2 > 9 ? '' : '0') + _i2, status: 'out' });
      if (s > 6) s = 0;
    }
    return swm;
  },
  monthSixWeek: function monthSixWeek() {
    var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var month = this.monthArrDays(m, y);
    var sixweek = [];
    for (var i = 0; i < 6; i++) {
      sixweek[i] = month.slice(i * 7, i * 7 + 7);
    }
    return sixweek;
  },
  formatMonth: function formatMonth(m) {
    m = parseInt(m) + 1;
    return m > 12 ? '01' : m > 9 ? m : '0' + m;
  },
  validMonth: function validMonth() {
    var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!m || m < 0 || m > 11) return new Date().getMonth();
    return m;
  },
  formatDate: function formatDate(oDate) {
    var dataa = new Date(oDate);
    return dataa.toISOString().slice(0, 10).replace(/-/g, '');
  },
  getThisWeek: function getThisWeek() {
    var now = new Date();
    var sunday = now.setDate(now.getDate() - now.getDay());
    var saturday = now.setDate(now.getDate() + 6);
    console.log(this.formatDate(sunday) + ' ... ' + this.formatDate(saturday));
  }
});

/***/ }),

/***/ "cvTa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_c('table',[(_vm.state === 'Day')?[_c('tr',[_c('td',[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.prevMonth()}}},[_vm._v("«")])]),_vm._v(" "),_c('td',{attrs:{"colspan":"3"},on:{"click":function($event){$event.preventDefault();_vm.state = 'Month'}}},[_vm._v(_vm._s(_vm.monthName(_vm.oDate.m)))]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.oDate.y))]),_vm._v(" "),_c('td',[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.nextMonth()}}},[_vm._v("»")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._l((_vm.month),function(week,windex){return _c('tr',_vm._l((week),function(day){return _c('td',{class:day.status,on:{"click":function($event){_vm.pickDate(day.yyyymmdd, windex)}}},[_vm._v(_vm._s(day.d))])}))})]:_vm._e(),_vm._v(" "),(_vm.state === 'Month')?[_c('tr',[_c('td',[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.oDate.y-= 1}}},[_vm._v("«")])]),_vm._v(" "),_c('td',{attrs:{"colspan":"2"}},[_vm._v(_vm._s(_vm.oDate.y))]),_vm._v(" "),_c('td',[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.oDate.y+= 1}}},[_vm._v("»")])])]),_vm._v(" "),_c('tr',{staticClass:"month"},[_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(0)}}},[_vm._v("Janeiro")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(1)}}},[_vm._v("Fevereiro")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(2)}}},[_vm._v("Março")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(3)}}},[_vm._v("Abril")])]),_vm._v(" "),_c('tr',{staticClass:"month"},[_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(4)}}},[_vm._v("Maio")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(5)}}},[_vm._v("Junho")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(6)}}},[_vm._v("Julho")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(7)}}},[_vm._v("Agosto")])]),_vm._v(" "),_c('tr',{staticClass:"month"},[_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(8)}}},[_vm._v("Setembro")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(9)}}},[_vm._v("Outubro")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(10)}}},[_vm._v("Novembro")]),_vm._v(" "),_c('td',{on:{"click":function($event){$event.preventDefault();_vm.selectMonth(11)}}},[_vm._v("Dezembro")])])]:_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Dom")]),_vm._v(" "),_c('td',[_vm._v("Seg")]),_vm._v(" "),_c('td',[_vm._v("Ter")]),_vm._v(" "),_c('td',[_vm._v("Qua")]),_vm._v(" "),_c('td',[_vm._v("Qui")]),_vm._v(" "),_c('td',[_vm._v("Sex")]),_vm._v(" "),_c('td',[_vm._v("Sáb")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dCFA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist',
  data: function data() {
    return {
      loading: false,
      clientes: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        // console.log(response.body)
        if (response.body.length > 0) {
          this.clientes = response.body;
        } else {
          this.clientes = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    addNew: function addNew() {
      this.$router.push({ path: '/cliente/0' });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/cliente/' + cod });
    },
    select4agenda: function select4agenda(cod) {
      this.$router.push({ path: '/agenda/c/' + cod });
    },
    select4grupo: function select4grupo(grupo) {
      this.$router.push({ path: '/clientes/cob/' + grupo });
    },
    useIt: function useIt(input) {
      if (input !== '0') {
        var classe = 'label label-primary';
        if (input[0] === '-') {
          classe = 'label label-danger';
        }
        return '<span class=\'' + classe + '\'>' + input + '</span>';
      }
    }
  },
  created: function created() {
    this.maskCnpj = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].cnpj;
    this.maskMonetario = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].monetario;
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].telefone;
    var keyword = this.$route.query.s;
    this.load({ 'cob': true, 'keyword': keyword });
  },
  watch: {
    '$route': function $route(to, from) {
      var keyword = this.$route.query.s;
      this.load({ 'cob': true, 'keyword': keyword });
    }
  }
});

/***/ }),

/***/ "dRRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clientes_vue__ = __webpack_require__("LlnO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc361bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clientes_vue__ = __webpack_require__("sj3E");
function injectStyle (ssrContext) {
  __webpack_require__("bOZH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bc361bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Clientes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc361bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Clientes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "deti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemSelect_vue__ = __webpack_require__("RjTp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4a8cea0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemSelect_vue__ = __webpack_require__("1nYz");
function injectStyle (ssrContext) {
  __webpack_require__("OHIO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d4a8cea0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4a8cea0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dnRr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-12 text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/clientes/sup"}},[_vm._v("Suporte")]),_vm._v(" | \n      "),_c('router-link',{attrs:{"to":"/clientes/cob"}},[_vm._v("Cobrança")])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.clientes.length)+" resultado(s) encontrados")]),_vm._v(" "),(this.$route.query.s)?_c('small',[_vm._v(" que contém '"+_vm._s(this.$route.query.s)+"'")]):_vm._e()]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.clientes),function(cliente){return _c('tr',{class:cliente.situacao==='2'? 'text-danger bg-danger' : ''},[_c('td',{staticClass:"nowrap"},[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(cliente.cod)}}}),_vm._v(" "),(cliente.grupo)?_c('a',{staticClass:"glyphicon glyphicon-th-large",attrs:{"title":cliente.grupo},on:{"click":function($event){$event.preventDefault();_vm.select4grupo(cliente.grupo)}}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(_vm.maskCnpj(cliente.cnpj)))]),_vm._v(" "),_c('td',[(cliente.psweblink!=='')?_c('a',{staticClass:"glyphicon glyphicon-home",attrs:{"href":cliente.psweblink,"target":"_blank"}}):_vm._e(),_vm._v("\n        "+_vm._s(cliente.razao)),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(cliente.fantasia))]),_vm._v(" "),(cliente.situacao==='2')?_c('b',{staticClass:"bg-danger text-danger"},[_c('i',{staticClass:"glyphicon glyphicon-lock"}),_vm._v("Bloqueado. Não Atender!")]):_vm._e(),_vm._v(" "),(cliente.situacao==='0')?_c('b',{staticClass:"bg-warning text-danger"},[_c('i',{staticClass:"glyphicon glyphicon-delete"}),_vm._v("Ex Cliente. Não Atender!")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(cliente.chavecliente))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.endcidade !== '' ? cliente.endcidade : cliente.cobcidade))]),_vm._v(" "),_c('td',{staticClass:"lt500"},[(cliente.certificado!=='A1')?_c('div',{staticClass:"label label-danger"},[_vm._v(_vm._s(cliente.certificado))]):_vm._e(),_vm._v(" "),(cliente.uso==='linux')?_c('div',{staticClass:"label label-success"},[_vm._v("Linux")]):_vm._e(),_vm._v(" "),(cliente.situacao==='3')?_c('div',{staticClass:"label label-warning"},[_vm._v("Antigo")]):_vm._e(),_vm._v(" "),(cliente.unfe!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.unfe))}}):_vm._e(),_vm._v(" "),(cliente.ucfe!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.ucfe))}}):_vm._e(),_vm._v(" "),(cliente.unfse!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.unfse))}}):_vm._e(),_vm._v(" "),(cliente.umdfe!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.umdfe))}}):_vm._e(),_vm._v(" "),(cliente.ucte!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.ucte))}}):_vm._e(),_vm._v(" "),(cliente.uetiq!=='0')?_c('div',{staticClass:"use",domProps:{"innerHTML":_vm._s(_vm.useIt(cliente.uetiq))}}):_vm._e()]),_vm._v(" "),_c('td',_vm._l((cliente.telefone),function(telefone){return _c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero))),_c('br')])})),_vm._v(" "),_c('td',{staticClass:"lt500"},[_c('a',{staticClass:"glyphicon glyphicon-list",attrs:{"title":"Histórico"},on:{"click":function($event){$event.preventDefault();_vm.select4historico(cliente.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-book",attrs:{"title":"Agenda"},on:{"click":function($event){$event.preventDefault();_vm.select4agenda(cliente.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-flag",attrs:{"title":"Tarefa"},on:{"click":function($event){$event.preventDefault();_vm.select4tarefa(cliente.cod)}}})])])})],2),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("cnpj")]),_vm._v(" "),_c('td',[_vm._v("razao")]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("chave")]),_vm._v(" "),_c('td',[_vm._v("cidade")]),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("uso")]),_vm._v(" "),_c('td',[_vm._v("contato")]),_vm._v(" "),_c('td',{staticClass:"lt500"}),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dxC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Users',
  components: {},
  data: function data() {
    return {
      logado: false
    };
  },

  methods: {},
  created: function created() {
    this.logado = this.$root.auth;
  }
});

/***/ }),

/***/ "eEVu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eU7m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eqdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist',
  data: function data() {
    return {
      mesAno: '',
      loading: false,
      clientes: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.length > 0) {
          this.clientes = response.body;
        } else {
          this.clientes = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/cliente/' + cod });
    },
    select4agenda: function select4agenda(cod) {
      this.$router.push({ path: '/agenda/c/' + cod });
    },
    nfseMailLink: function nfseMailLink(emails) {
      var email = this.filterMail(emails, 'nfse');
      if (email) {
        return 'mailto:' + email + '?Subject=NFS-e%20PWS%20Informatica%20-%20Emitida%20em%20' + this.mesAno;
      } else {
        return '';
      }
    },
    boletoMailLink: function boletoMailLink(emails) {
      var email = this.filterMail(emails, 'boleto');
      if (email) {
        return 'mailto:' + email + '?Subject=Boleto%20PWS%20Informatica%20-%20Ref.%20' + this.mesAno;
      } else {
        return '';
      }
    },
    filterMail: function filterMail(emails, keyword) {
      var email = emails.filter(function (email) {
        return email.descricao === keyword;
      });
      if (email.length) {
        email = email[0];
        console.log(email.endereco);
        return email.endereco;
      } else {
        return false;
      }
    },
    verify: function verify(event) {
      event.target.className += ' text-muted';
    }
  },
  created: function created() {
    this.maskCnpj = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].cnpj;
    this.maskMonetario = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].monetario;
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].telefone;
    var keyword = this.$route.query.s;
    this.load({ 'docs': true, 'keyword': keyword });
    var data = new Date();
    if (data.getDate() < 20) {
      this.mesAno = data.getMonth() + 1 + '/' + data.getFullYear();
    } else {
      if (data.getMonth() === 11) {
        this.mesAno = '01/' + (data.getFullYear() + 1);
      } else {
        this.mesAno = data.getMonth() + 2 + '/' + data.getFullYear();
      }
    }
  },
  watch: {
    '$route': function $route(to, from) {
      var keyword = this.$route.query.s;
      this.load({ 'docs': true, 'keyword': keyword });
    }
  }
});

/***/ }),

/***/ "fDFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'agenda',
  props: ['hideFile', 'hideBold', 'hideAlign', 'hideColors', 'hideInserts'],
  data: function data() {
    return {
      active: false,
      caret: {
        hasSelection: false,
        anchorOffset: undefined,
        anchorElText: undefined,
        anchorEl: undefined,
        pathList: undefined
      },
      btn: {
        bold: false,
        italic: false,
        underline: false,
        strikeThrough: false,
        superScript: false,
        subScript: false,
        foreColor: false,
        foreColorHex: 'inherit',
        backColor: false,
        backColorHex: 'inherit',
        insertOrderedList: false,
        insertUnorderedList: false,
        justifyLeft: false,
        justifyCenter: false,
        justifyRight: false,
        justifyFull: false
      },
      seeFontColors: false,
      foreColorHex: 'inherit',
      seeBackColors: false,
      backColorHex: 'inherit',
      seeFontSizes: false,
      selectfontSize: 1
    };
  },

  methods: {
    setContent: function setContent(html) {
      // console.log('Tentou mudar o conteudo')
      this.$refs.editor.innerHTML = html;
    },
    getContent: function getContent() {
      return this.$refs.editor.innerHTML;
    },
    fileNew: function fileNew() {
      this.$refs.editor.innerHTML = '';
    },
    returnCaret4Editor: function returnCaret4Editor() {
      if (!this.caret.hasSelection) {
        if (this.btn.bold !== document.queryCommandState('bold')) this.bold();
        if (this.btn.italic !== document.queryCommandState('italic')) this.italic();
        if (this.btn.underline !== document.queryCommandState('underline')) this.underline();
        if (this.btn.strikeThrough !== document.queryCommandState('strikeThrough')) this.strikeThrough();
        if (this.btn.superScript !== document.queryCommandState('superScript')) this.superScript();
        if (this.btn.subScript !== document.queryCommandState('subScript')) this.subScript();
        if (this.btn.foreColor && !document.queryCommandState('foreColor')) this.foreColor(false);
        if (this.btn.backColor !== document.queryCommandState('backColor')) this.backColor(false);
        this.btn.insertOrderedList = document.queryCommandState('insertOrderedList');
        this.btn.insertUnorderedList = document.queryCommandState('insertUnorderedList');
        this.btn.justifyLeft = document.queryCommandState('justifyLeft');
        this.btn.justifyCenter = document.queryCommandState('justifyCenter');
        this.btn.justifyRight = document.queryCommandState('justifyRight');
        this.btn.justifyFull = document.queryCommandState('justifyFull');
      }
    },
    returnCaret4LastKnowPosition: function returnCaret4LastKnowPosition() {
      var range = document.createRange();
      range.setStart(this.caret.anchorElText, this.caret.anchorOffset);
      range.collapse(true);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    },
    handlerKeyEnter: function handlerKeyEnter() {
      this.btn.insertOrderedList = document.queryCommandState('insertOrderedList');
      this.btn.insertUnorderedList = document.queryCommandState('insertUnorderedList');
    },
    updateCaretInfo: function updateCaretInfo() {
      var sel = window.getSelection();
      this.caret.hasSelection = !sel.isCollapsed; // Se o inicio da seleção é igual ao fim
      this.caret.anchorOffset = sel.anchorOffset;
      this.caret.anchorElText = sel.getRangeAt(0).startContainer;
      this.caret.anchorEl = this.caret.anchorElText.parentNode;
      this.returnCaret4Editor();
      this.recursiveNodeSearch(this.caret.anchorEl);
    },
    recursiveNodeSearch: function recursiveNodeSearch(nodeStart) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var range = document.createRange();
      path = nodeStart.nodeName + path;
      range.setStartAfter(nodeStart);
      range.collapse(true);
      var pNode = range.startContainer;
      if (pNode.nodeName === 'DIV') {
        // console.log('Achei a div' + path)
        this.caret.pathList = path === 'DIV' ? path : 'Div » ' + path;
      } else {
        // console.log('find path...')
        path = ' » ' + path;
        this.recursiveNodeSearch(pNode, path);
      }
    },
    handlerMouseDown: function handlerMouseDown() {
      // console.log('MouseDown')
      this.updateCaretInfo();
    },
    handlerMouseUp: function handlerMouseUp() {
      // console.log('MouseUp')
      this.updateCaretInfo();
    },
    bold: function bold() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.bold = !this.btn.bold;
      document.execCommand('bold', false);
    },
    italic: function italic() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.italic = !this.btn.italic;
      document.execCommand('italic', false);
    },
    underline: function underline() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.underline = !this.btn.underline;
      document.execCommand('underline', false);
    },
    strikeThrough: function strikeThrough() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.strikeThrough = !this.btn.strikeThrough;
      document.execCommand('strikeThrough', false);
    },
    superScript: function superScript() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.superScript = !this.btn.superScript;
      document.execCommand('superScript', false);
    },
    subScript: function subScript() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.subScript = !this.btn.subScript;
      document.execCommand('subScript', false);
    },
    foreColor: function foreColor() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.foreColor = !this.btn.foreColor;
      document.execCommand('foreColor', false, this.foreColorHex);
    },
    backColor: function backColor() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) this.btn.backColor = !this.btn.backColor;
      document.execCommand('backColor', false, this.backColorHex);
    },
    setColor: function setColor(color, fob) {
      if (fob === 'b') {
        this.seeBackColors = false;
        this.backColorHex = color;
      } else {
        this.seeFontColors = false;
        this.foreColorHex = color;
      }
    },
    insertOrderedList: function insertOrderedList() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) {
        this.btn.insertOrderedList = !this.btn.insertOrderedList;
        this.btn.insertUnorderedList = false;
      }
      this.returnCaret4LastKnowPosition();
      document.execCommand('insertOrderedList', false);
    },
    insertUnorderedList: function insertUnorderedList() {
      var click = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (click) {
        this.btn.insertUnorderedList = !this.btn.insertUnorderedList;
        this.btn.insertOrderedList = false;
      }
      this.returnCaret4LastKnowPosition();
      document.execCommand('insertUnorderedList', false);
    },
    justifyLeft: function justifyLeft() {
      var bool = this.btn.justifyLeft = !this.btn.justifyLeft;
      document.execCommand('justifyLeft', false);
      if (bool) {
        this.btn.justifyCenter = this.btn.justifyRight = this.btn.justifyFull = false;
      }
    },
    justifyCenter: function justifyCenter() {
      var bool = this.btn.justifyCenter = !this.btn.justifyCenter;
      document.execCommand('justifyCenter', false);
      if (!bool) {
        this.justifyLeft();
      } else {
        this.btn.justifyLeft = this.btn.justifyRight = this.btn.justifyFull = false;
      }
    },
    justifyRight: function justifyRight() {
      var bool = this.btn.justifyRight = !this.btn.justifyRight;
      document.execCommand('justifyRight', false);
      if (!bool) {
        this.justifyLeft();
      } else {
        this.btn.justifyLeft = this.btn.justifyCenter = this.btn.justifyFull = false;
      }
    },
    justifyFull: function justifyFull() {
      var bool = this.btn.justifyFull = !this.btn.justifyFull;
      document.execCommand('justifyFull', false);
      if (!bool) {
        this.justifyLeft();
      } else {
        this.btn.justifyLeft = this.btn.justifyRight = this.btn.justifyCenter = false;
      }
    },
    fontSize: function fontSize(size) {
      this.returnCaret4LastKnowPosition();
      document.execCommand('insertHTML', false, '&nbsp;<font size="' + size + '">Titulo</font>&nbsp;');
    },
    createLink: function createLink() {
      var href = prompt('Digite o endereço da internet...');
      if (href.substr(0, 4).toLowerCase() === 'www.') {
        var txt = window.getSelection().toString();
        document.execCommand('insertHTML', false, '<a href="http://' + href + '" target="_blank">' + txt + '</a>');
      }
    },
    insertImage: function insertImage() {},
    removeFormat: function removeFormat(cmdId) {
      document.execCommand('removeFormat', false, cmdId);
    }
  }
});

/***/ }),

/***/ "flJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__ = __webpack_require__("iyFI");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Ferias',
  components: {
    Calendario: __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__["a" /* default */]
  },
  data: function data() {
    return {
      ok: true,
      showCalendar: 0,
      rows: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getferias.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response);
        this.rows = response.body.rows;
      }, function (error) {
        console.log(error);
      });
    },
    save: function save(params) {
      var url = './api/php/getferias.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        this.rows = response.body.rows;
      }, function (error) {
        console.log(error);
      });
    },
    addAno: function addAno() {
      this.save({ crud: 'c', cod: this.$root.cod });
    },
    setWeek: function setWeek(aDay, zDay, week) {
      console.log('As férias serão entre ' + aDay + ' e ' + zDay);
      var codigo = this.showCalendar.toString().substring(5, 7);
      this.save({ crud: 'u', cod: codigo, data: aDay });
      this.showCalendar = 0;
    },
    normalizeData: function normalizeData(data) {
      if (data) {
        return data.substring(6, 8) + '/' + data.substring(4, 6) + '/' + data.substring(0, 4);
      } else {
        return '';
      }
    }
  },
  created: function created() {
    this.load();
  }
});

/***/ }),

/***/ "gRhM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'manuallist',
  data: function data() {
    return {
      loading: false,
      manuais: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getmanual.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          this.manuais = response.body.rows;
        } else {
          this.manuais = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/manual/u/' + cod });
    },
    select4list: function select4list(cod) {
      this.$router.push({ path: '/manuais/' + cod });
    },
    formatData: function formatData(date) {
      return date.substring(8, 10) + '-' + date.substring(5, 7) + '-' + date.substring(0, 4);
    }
  },
  created: function created() {
    var cat = this.$route.query.c;
    var subcat = this.$route.query.sc;
    this.load({ 'cat': cat, 'subcat': subcat });
  },
  watch: {
    '$route': function $route(to, from) {
      var cat = this.$route.query.c;
      var subcat = this.$route.query.sc;
      this.load({ 'cat': cat, 'subcat': subcat });
    }
  }
});

/***/ }),

/***/ "gZDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue__ = __webpack_require__("8mIE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fee7035_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agenda_vue__ = __webpack_require__("IXlI");
function injectStyle (ssrContext) {
  __webpack_require__("XU/M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fee7035"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fee7035_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agenda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h85n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'telefone',
  props: ['emails'],
  data: function data() {
    return {
      showform: false,
      iptEndereco: '',
      iptDescricao: '',
      index: -1
    };
  },

  methods: {
    add: function add() {
      var item = { 'endereco': this.iptEndereco, 'descricao': this.iptDescricao };
      this.$emit('add', item, 'email', this.index);
      this.reset();
    },
    update: function update(index) {
      var email = this.emails[index];
      this.iptEndereco = email.endereco;
      this.iptDescricao = email.descricao;
      this.index = index;
      this.showform = true;
      this.focus();
    },
    remove: function remove(index) {
      this.$emit('remove', 'email', index);
    },
    focus: function focus() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.iptendereco.focus();
      });
    },
    reset: function reset() {
      this.showform = false;
      this.iptEndereco = '';
      this.iptDescricao = '';
      this.index = -1;
    }
  }
});

/***/ }),

/***/ "h9BO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarForm_vue__ = __webpack_require__("kUk0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ae52a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarForm_vue__ = __webpack_require__("ZSsC");
function injectStyle (ssrContext) {
  __webpack_require__("xNas")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58ae52a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ae52a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hF4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-login"},[_c('h3',[_vm._v("HUB")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usuario),expression:"usuario"}],ref:"iptlogin",staticClass:"form-control",attrs:{"type":"text","placeholder":"Login"},domProps:{"value":(_vm.usuario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.usuario=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.senha),expression:"senha"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Senha"},domProps:{"value":(_vm.senha)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login()},"input":function($event){if($event.target.composing){ return; }_vm.senha=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.login()}}},[_vm._v("Entrar")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":""}},[_c('i',{staticClass:"glyphicon glyphicon-user"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":""}},[_c('i',{staticClass:"glyphicon glyphicon-lock"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i8lr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iyFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__ = __webpack_require__("YT0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083c73b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__ = __webpack_require__("cvTa");
function injectStyle (ssrContext) {
  __webpack_require__("Q0GH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-083c73b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_083c73b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jJE4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k+IU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pacote_vue__ = __webpack_require__("15CE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1697f12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pacote_vue__ = __webpack_require__("w0zJ");
function injectStyle (ssrContext) {
  __webpack_require__("rlO3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1697f12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pacote_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1697f12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pacote_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kISe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailRel_vue__ = __webpack_require__("Nhny");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5673a2c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailRel_vue__ = __webpack_require__("oB25");
function injectStyle (ssrContext) {
  __webpack_require__("7B7v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5673a2c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailRel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5673a2c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailRel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kUk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__ = __webpack_require__("Y7kT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Calendar__ = __webpack_require__("iyFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    wysiwyg: __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__["a" /* default */], Calendario: __WEBPACK_IMPORTED_MODULE_2__Calendar__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      crud_action: '',
      showCalendar: false,
      form: {
        cod: 0,
        codcli: 0,
        flag: '3',
        tipo: '0',
        situacao: '0',
        dt_insert: '',
        dt_limite: null,
        dt_resolvido: null,
        codautor: '0',
        codresponsavel: '1',
        codsolucionador: '0',
        descr: '',
        descricao: '<b>teste</b>',
        solucao: '',
        codlocal: '15'
      },
      cliente: {
        razao: '',
        endereco: '',
        telefone: []
      }
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/gettarefa.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        this.fetchData(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    loadCliente: function loadCliente(cod) {
      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'cod': cod })).then(function (response) {
        // console.log(response.body)
        this.fetchDataCliente(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    fetchData: function fetchData(o) {
      this.form = o;
      this.$refs.descricao.setContent(o.descricao);
      this.$refs.solucao.setContent(o.solucao);
      this.loadCliente(o.codcli);
    },
    fetchDataCliente: function fetchDataCliente(o) {
      console.log(o);
      this.form.codcli = o.cod;
      this.cliente.cod = o.cod;
      this.cliente.razao = o.razao;
      this.cliente.telefone = o.telefone;
      if (o.endrua === '') {
        this.cliente.endereco = o.cobrua + ', ' + o.cobnumero + ' ' + o.cobcompl + ' - ' + o.cobbairro + ', ' + o.cobcidade + ' - ' + o.cobuf;
      } else {
        this.cliente.endereco = o.endrua + ', ' + o.endnumero + ' ' + o.endcompl + ' - ' + o.endbairro + ', ' + o.endcidade + ' - ' + o.enduf;
      }
    },
    save: function save() {
      if (this.form.situacao === '6') this.form.tmpcodsolucionador = this.$root.cod;
      this.form.descricao = this.$refs.descricao.getContent();
      this.form.solucao = this.$refs.solucao.getContent();
      var url = './api/php/addtarefa.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form)).then(function (response) {
        console.log(response.body);
        if (this.crud === 'c') {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Tarefa salva.', 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Tarefa alterada', '', 'success');
        }
        this.closeForm();
      }, function (error) {
        console.log(error);
      });
    },
    setDate: function setDate(date) {
      console.log('DtPicked: ' + date);
      this.showCalendar = false;
      this.$refs.dtlimitedisplay.value = this.formatData(date);
      this.form.dt_limite = date;
    },
    formatData: function formatData(date) {
      if (date.length > 0) {
        return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4);
      }
    },
    closeForm: function closeForm() {
      this.$router.go(-1);
    }
  },
  created: function created() {
    var crud = this.$route.params.crud;
    var cod = this.$route.params.id;
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_4__Mask_js__["a" /* default */].telefone;
    if (crud === 'c') {
      // Criar nova tarefa
      console.log('Criando nova tarefa');
      this.crud_action = 'Nova';
      this.form.codautor = this.$root.cod;
      this.loadCliente(cod);
    } else if (crud === 'u') {
      // Altera uma tarefa
      console.log('Alterando uma tarefa');
      this.crud_action = 'Alterando (#' + cod + ')';
      this.load({ 'cod': cod });
    } else {
      console.log('CRUD INVÁLIDO EM FORM TAREFA');
    }
  }
});

/***/ }),

/***/ "lEH0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('div',{staticClass:"container"},[_c('h1'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 text-left"},[_vm._v("\n      Olá "+_vm._s(this.$root.nome)+"!\n      "),(_vm.smart.agenda)?[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"labels"},_vm._l((_vm.smart.agenda),function(compromisso){return _c('div',{staticClass:"col-sm-4"},[_c('a',{staticClass:"glyphicon glyphicon-book",on:{"click":function($event){$event.preventDefault();_vm.select4agenda(compromisso.cod)}}}),_vm._v(" "),_c('small',[_c('cite',[_vm._v(_vm._s(compromisso.razao.substring(0,22))+"...")]),_vm._v(" "),_c('span',{staticClass:"label label-default"},[_vm._v(_vm._s(compromisso.fantasia.substring(0,25)))]),_vm._v(" "),_c('b',[_vm._v(_vm._s(compromisso.hora)+" - "+_vm._s(compromisso.endcidade!==''? compromisso.endcidade : compromisso.cobcidade))])])])}))]:_vm._e(),_vm._v(" "),(_vm.smart.tarefas)?[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"labels"},_vm._l((_vm.smart.tarefas),function(tarefa){return _c('div',{staticClass:"col-sm-4"},[_c('a',{staticClass:"glyphicon glyphicon-flag",on:{"click":function($event){$event.preventDefault();_vm.select4tarefa(tarefa.cod)}}}),_vm._v(" "),_c('cite',[_vm._v(_vm._s(tarefa.razao.substring(0,22))+"...")]),_vm._v(" "),(tarefa.flagdescr==='Normal' )?_c('span',{staticClass:"label label-default"},[_vm._v(_vm._s(tarefa.fantasia.substring(0,25)))]):(tarefa.flagdescr==='Moderado')?_c('span',{staticClass:"label label-warning"},[_vm._v(_vm._s(tarefa.fantasia.substring(0,25)))]):_c('span',{staticClass:"label label-danger"},[_vm._v(_vm._s(tarefa.fantasia.substring(0,25)))]),_vm._v("\n          Prazo "+_vm._s(tarefa.dt_limite)+"\n        ")])}))]:_vm._e()],2),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Sua agenda hoje...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Suas Tarefas...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 text-left"},[_c('h3',[_vm._v("Downloads")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.google.com/intl/pt-BR_ALL/drive/","target":"_blank"}},[_vm._v("Google Drive - Backups")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"glyphicon glyphicon-user"}),_vm._v("  ps2000r@gmail.com")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"glyphicon glyphicon-lock"}),_vm._v("  2010201032263923")]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.google.com/intl/pt-BR_ALL/drive/","target":"_blank"}},[_vm._v("Google Drive - Instaladores")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"glyphicon glyphicon-user"}),_vm._v("  psrepos@gmail.com")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"glyphicon glyphicon-lock"}),_vm._v("  ps32263923")]),_vm._v(" "),_c('a',{attrs:{"href":"ftp://ps2000.ddns.com.br:2100","target":"_blank"}},[_vm._v("FTP - ftp://ps2000.ddns.com.br:2100")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"glyphicon glyphicon-user"}),_vm._v("  suporte")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"glyphicon glyphicon-lock"}),_vm._v("  suporte")]),_vm._v(" "),_c('a',{attrs:{"href":"http://psconsultoria.com.br","target":"_blank"}},[_vm._v("Site PS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lMu7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3435070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("lEH0");
function injectStyle (ssrContext) {
  __webpack_require__("2dnT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3435070"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3435070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5ee638e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("K+lu");
function injectStyle (ssrContext) {
  __webpack_require__("sAS0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5ee638e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5ee638e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lh58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[(_vm.showForm)?_c('div',{staticClass:"form"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.form.chavecliente))]),_c('b',[_vm._v("Pacote:")]),_vm._v(" "+_vm._s(_vm.form.packname))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.anotacoes),expression:"form.anotacoes"}],attrs:{"placeholder":"Anotações referentes a atualização deste pacote neste cliente específico..."},domProps:{"value":(_vm.form.anotacoes)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "anotacoes", $event.target.value)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){$event.preventDefault();_vm.saveAnotacoes()}}},[_vm._v("Salvar anotações")]),_vm._v(" "),_c('button',{staticClass:"btn btn-muted",on:{"click":function($event){$event.preventDefault();_vm.closeForm()}}},[_vm._v("Sair sem alterar")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/pacotes"}},[_vm._v("Pacotes")]),_vm._v(" "),(_vm.rel!==1)?_c('router-link',{attrs:{"to":"/pacotes/resumo"}},[_vm._v(" | Resumo")]):_vm._e(),_vm._v(" "),(_vm.pacotes[0] !== undefined && _vm.rel === 1)?[_vm._v(" » "+_vm._s(_vm.pacotes[0].packname)+" | "),_c('small',[_vm._v("Atualizados "+_vm._s(_vm.pacotesAtu)+" / Pendentes "+_vm._s(_vm.pacotes.length - _vm.pacotesAtu))])]:_vm._e()],2)]),_vm._v(" "),(_vm.rel===0)?_c('table',{staticClass:"table-striped"},[_c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-collapse-down",on:{"click":function($event){$event.preventDefault();_vm.collapseAll()}}}),_vm._v("\n        Pacote\n      ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("File(s)")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Data Upload")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Data Download")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Status")])]),_vm._v(" "),_vm._l((_vm.pacotes),function(item,key){return [(item[0].razao !== null)?[_c('tr',[_c('td',{staticClass:"bg-header",attrs:{"colspan":"4"}},[_c('a',{staticClass:"glyphicon glyphicon-collapse-down",attrs:{"data-toggle":"collapse","data-target":'.'+key}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(key))]),_vm._v(" - "),_c('span',{staticClass:"razao"},[_vm._v(_vm._s(item[0].razao))])]),_vm._v(" "),_c('td',{staticClass:"text-center bg-header"},[_c('b',{staticClass:"text-success"},[_vm._v(_vm._s(item[0].total - item[0].pendentes)+" Atualizada(s)")]),_vm._v(" "),(item[0].pendentes>0)?_c('b',{staticClass:"text-danger"},[_vm._v("  |   "+_vm._s(item[0].pendentes)+" Pendente(s)")]):_vm._e()])]),_vm._v(" "),_vm._l((item),function(x){return _c('tr',{class:(_vm.nocollapse === true)? '' : 'collapse ' + key},[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pushpin",on:{"click":function($event){$event.preventDefault();_vm.loadAnotacao(x.cod,key)}}}),_vm._v(" "),_c('a',{attrs:{"title":"Ver os clientes desta atualização"},on:{"click":function($event){$event.preventDefault();_vm.select4thispack(x.cod)}}},[_vm._v(_vm._s(x.packname))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('b',[_vm._v(_vm._s(x.qtd))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatData(x.dt_upload)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n          "+_vm._s(x.dt_download !== null? _vm.formatData(x.dt_download) : '-')+"\n          "),(x.dt_download === null)?_c('a',{staticClass:"glyphicon glyphicon-ok-circle text-success",attrs:{"title":"Marcar como atualizado"},on:{"click":function($event){$event.preventDefault();_vm.updateDtDownload(x.cod,key,true)}}}):_c('a',{staticClass:"glyphicon glyphicon-remove-circle text-danger",attrs:{"title":"Apagar data de download"},on:{"click":function($event){$event.preventDefault();_vm.updateDtDownload(x.cod,key,false)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(x.dt_download !== null)?_c('i',{staticClass:"glyphicon glyphicon-ok-sign text-success"}):_c('i',{staticClass:"glyphicon glyphicon-remove-sign text-danger"})])])})]:_vm._e()]})],2):_vm._e(),_vm._v(" "),(_vm.rel===1)?_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.pacotes),function(x){return [(x.razao !== null)?_c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pushpin",on:{"click":function($event){$event.preventDefault();_vm.loadAnotacao(x.cod,x.chavecliente)}}}),_vm._v(" "),(x.link!=='')?_c('a',{staticClass:"glyphicon glyphicon-home",attrs:{"href":x.link,"target":"_blank"}}):_vm._e(),_vm._v("\n            "+_vm._s(x.chavecliente)+"\n            "),(x.situacao==='2')?_c('span',{staticClass:"text-danger"},[_c('b',{staticClass:"glyphicon glyphicon-lock"}),_vm._v(" Bloqueado")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._l((x.telefone),function(tel){return [_c('span',[_vm._v(_vm._s(_vm.maskTelefone(tel.numero)))]),_c('br')]})],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('b',[_vm._v(_vm._s(x.qtd))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.formatData(x.dt_upload)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n            "+_vm._s(x.dt_download !== null? _vm.formatData(x.dt_download) : '-')+"\n            "),(x.dt_download === null)?_c('a',{staticClass:"glyphicon glyphicon-ok-circle text-success",attrs:{"title":"Marcar como atualizado"},on:{"click":function($event){$event.preventDefault();_vm.updateDtDownload(x.cod,x.chavecliente,true)}}}):_c('a',{staticClass:"glyphicon glyphicon-remove-circle text-danger",attrs:{"title":"Apagar data de download"},on:{"click":function($event){$event.preventDefault();_vm.updateDtDownload(x.cod,x.chavecliente,false)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(x.dt_download !== null)?_c('i',{staticClass:"glyphicon glyphicon-ok-sign text-success"}):_c('i',{staticClass:"glyphicon glyphicon-remove-sign text-danger"})])]):_vm._e()]})],2):_vm._e(),_vm._v(" "),(_vm.rel===2)?_c('table',{staticClass:"center"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.pacotes),function(x,index){return [_vm._v("\n          "+_vm._s(_vm.percentual(x.downloads, x.total, index))+"\n          "),_c('tr',[_c('td',[_c('a',{attrs:{"title":"Ver os clientes desta atualização"},on:{"click":function($event){$event.preventDefault();_vm.select4thispack(x.cod)}}},[_vm._v(_vm._s(x.packname))])]),_vm._v(" "),_c('td',[_c('b',{class:x.percent < 30? 'text-danger' : x.percent < 50 ? 'text-warning' : 'text-success'},[_vm._v("\n                "+_vm._s(x.percent < 100? x.percent + '%' : 'OK')+"\n              ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(x.total - x.downloads))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatData(x.last_download)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatData(x.dt_upload)))])])]})],2):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Cliente")]),_vm._v(" "),_c('td',[_vm._v("Contato")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("File(s)")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Data Upload")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Data Download")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Status")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Atualização")]),_vm._v(" "),_c('td',[_vm._v("Atualizados")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Pendentes")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Último Download")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Upload")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n4ez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form_root"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/usuarios"}},[_vm._v("Usuários")]),_vm._v(" » "+_vm._s(_vm.crud_action)+" "),_c('button',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();_vm.saveForm()}}},[_vm._v("Salvar")])],1),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Cód.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cod),expression:"form.cod"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"cod","disabled":""},domProps:{"value":(_vm.form.cod)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cod", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Nome")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.nome),expression:"form.nome"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Nome do Usuário"},domProps:{"value":(_vm.form.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "nome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Login")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.login),expression:"form.login"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"login de acesso"},domProps:{"value":(_vm.form.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "login", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.pass),expression:"form.pass"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Senha"},domProps:{"value":(_vm.form.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "pass", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Senha - Confirmação")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],staticClass:"form-control",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  data: function data() {
    return {
      usuario: '',
      senha: ''
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getuser.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response);
        var login = response.body.login;
        if (login.status) {
          this.$root.auth = true;
          this.$root.cod = login.cod;
          this.$root.nome = login.nome;
          this.$root.nivel = login.nivel;
          this.$router.push({ path: '/home' });
        } else {
          this.usuario = '';
          this.senha = '';
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Ops...', login.msg, 'error');
        }
      }, function (error) {
        console.log(error);
      });
    },
    login: function login() {
      if (this.login === '' || this.senha === '') {
        __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Campos Obrigatórios', 'Favor informar login e senhas para acesso', 'error');
      } else {
        this.load({ 'login': this.usuario, 'pass': this.senha });
      }
    }
  },
  created: function created() {
    var _this = this;

    if (this.$root.auth) {
      this.$router.push({ path: '/home' });
    } else {
      this.$nextTick(function () {
        _this.$refs.iptlogin.focus();
      });
    }
  }
});

/***/ }),

/***/ "nW8a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelCob_vue__ = __webpack_require__("dCFA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc89b78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelCob_vue__ = __webpack_require__("5Qph");
function injectStyle (ssrContext) {
  __webpack_require__("eU7m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fc89b78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelCob_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fc89b78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelCob_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "naUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('label',{staticClass:"col-sm-12"},[_vm._v("\n        Email\n        "),(_vm.showform==false)?_c('a',{staticClass:"glyphicon glyphicon-plus",on:{"click":function($event){$event.preventDefault();_vm.showform=true;_vm.focus()}}}):_vm._e(),_vm._v(" "),(_vm.showform==true)?_c('small',{staticClass:"text-primary"},[_c('b',[_vm._v("Pressione ESC para sair")])]):_vm._e()]),_vm._v(" "),(_vm.showform)?_c('div',{staticClass:"col-sm-12 form",on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.add()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.reset()}]}},[_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptEndereco),expression:"iptEndereco"}],ref:"iptendereco",staticClass:"form-control",attrs:{"type":"text","placeholder":"endereço de em@il"},domProps:{"value":(_vm.iptEndereco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iptEndereco=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptDescricao),expression:"iptDescricao"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Contato"},domProps:{"value":(_vm.iptDescricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iptDescricao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.add()}}},[_vm._v("Adicionar")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('ul',{staticClass:"list-inline"},_vm._l((_vm.emails),function(email,index){return _c('li',[_c('span',{staticClass:"text-primary"},[_c('a',{attrs:{"href":'mailto:'+email.endereco}},[_vm._v(_vm._s(email.endereco))])]),_c('br'),_vm._v(" "),_c('small',[_vm._v("..."+_vm._s(email.descricao))]),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-pencil",on:{"click":function($event){$event.preventDefault();_vm.update(index)}}}),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-remove",on:{"click":function($event){$event.preventDefault();_vm.remove(index)}}})])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "npPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/tarefas"}},[_vm._v("Histórico")])],1)]),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v("Filtros\n        "),(!_vm.showFilters)?_c('a',{staticClass:"glyphicon glyphicon-eye-open",on:{"click":function($event){$event.preventDefault();_vm.showFilters=true}}}):_vm._e(),_vm._v(" "),(_vm.showFilters)?_c('a',{staticClass:"glyphicon glyphicon-eye-close",on:{"click":function($event){$event.preventDefault();_vm.showFilters=false}}}):_vm._e()])]),_vm._v(" "),(_vm.showFilters)?[_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Responsável")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.coduser),expression:"filters.coduser"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "coduser", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Alguem (Todos)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Fabio")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Felipe")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Jair")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Josue")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Lucas")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Prado")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Regis")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Roberto")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Rodrigo")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("Sanguine")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("Valni")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.situacao),expression:"filters.situacao"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filters, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"*"}},[_vm._v("Agenda e Tarefas")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Agenda")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Tarefas")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Data Minima")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{ref:"dtmindisplay",staticClass:"form-control",attrs:{"value":"01/01/1900","type":"text","disabled":""}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendarMin=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]),_vm._v(" "),(_vm.showCalendarMin)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDateMin}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',{attrs:{"for":""}},[_vm._v("Data Máxima")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{ref:"dtmaxdisplay",staticClass:"form-control",attrs:{"value":"31/12/9999","type":"text","disabled":""}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendarMax=true}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]),_vm._v(" "),(_vm.showCalendarMax)?_c('Calendario',{staticClass:"calendario",on:{"pickDate":_vm.setDateMax}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('label',[_vm._v("Aplicar filtro")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.searchWithFilters()}}},[_vm._v("Pesquisar")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('small',[_vm._v(_vm._s(_vm.numrows)+" evento(s) encontrados, divididos entre "),_c('b',[_vm._v(_vm._s(_vm.numheaders))]),_vm._v(" clientes.")]),_vm._v(" "),(this.$route.query.s)?_c('small',[_vm._v(" que contém '"+_vm._s(this.$route.query.s)+"'")]):_vm._e()])],2),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.fatos),function(item,key){return [_c('tr',[_c('td',{staticStyle:{"background":"#e1e1e1"},attrs:{"colspan":"6"}},[_c('b',[_vm._v(_vm._s(key))])])]),_vm._v(" "),_vm._l((item),function(fato){return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.normalizeDate(fato.dt)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(fato.situacao))]),_vm._v(" "),_c('td',[(fato.situacao==='Agenda')?_c('a',{staticClass:"glyphicon glyphicon-book",attrs:{"title":"Ver Compromisso"},on:{"click":function($event){$event.preventDefault();_vm.select4agenda(fato.cod)}}}):_c('a',{staticClass:"glyphicon glyphicon-flag",attrs:{"title":"Ver Tarefa"},on:{"click":function($event){$event.preventDefault();_vm.select4tarefa(fato.cod)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(fato.descr))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(fato.funcionario))])])})]})],2),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Data")]),_vm._v(" "),_c('td',[_vm._v("Situacão")]),_vm._v(" "),_c('td',[_vm._v("Ver")]),_vm._v(" "),_c('td',[_vm._v("Descrição")]),_vm._v(" "),_c('td',[_vm._v("Responsável")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nwGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mask_js__ = __webpack_require__("HVS0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CliFormEndereco_vue__ = __webpack_require__("4a3+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CliFormTelefone__ = __webpack_require__("Fw8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CliFormEmail_vue__ = __webpack_require__("OrLa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CliFormAcesso_vue__ = __webpack_require__("4t5B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'form',
  components: { endereco: __WEBPACK_IMPORTED_MODULE_2__CliFormEndereco_vue__["a" /* default */], telefones: __WEBPACK_IMPORTED_MODULE_3__CliFormTelefone__["a" /* default */], emails: __WEBPACK_IMPORTED_MODULE_4__CliFormEmail_vue__["a" /* default */], acessos: __WEBPACK_IMPORTED_MODULE_5__CliFormAcesso_vue__["a" /* default */] },
  data: function data() {
    return {
      crud_action: '',
      form: {
        cod: 0,
        chavecliente: '',
        grupo: '',
        situacao: '4',
        razao: '',
        fantasia: '',
        cnpj: '',
        ie: '',
        cobdia: 1,
        cobvalor: 'R$ 0,00',
        recebenfse: false,
        emailnfse: false,
        emailboleto: false,
        cob: {},
        end: {},
        telefone: [],
        email: [],
        acesso: [],
        uso: 'windows',
        certificado: 'A1',
        unfe: '0',
        ucfe: '0',
        unfse: '0',
        umdfe: '0',
        ucte: '0',
        uetiq: '0',
        uremessa: '0',
        psweblink: '',
        excluido: false
      }
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        // console.log(response)
        this.fetchData(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    save: function save(form) {
      var url = './api/php/addcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(form)).then(function (response) {
        console.log(response.body);
        if (form.cod === 0) {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Sucesso', form.razao + ' adicionado a lista de clientes', 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Sucesso', form.razao + ' alterado com sucesso', 'success');
        }
        this.closeForm();
      }, function (error) {
        console.log(error);
      });
    },
    remove: function remove() {
      var cod = this.form.cod;
      var url = './api/php/removecliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'cod': cod })).then(function (response) {
        console.log(response);
        __WEBPACK_IMPORTED_MODULE_6_sweetalert___default()('Excluído com sucesso', this.form.razao + ' foi excluído.', 'success');
      }, function (error) {
        console.log(error);
      });
    },
    fetchData: function fetchData(o) {
      this.form = o;
      this.form.cnpj = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].cnpj(o.cnpj);
      this.form.ie = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].ie(o.ie);
      this.form.cobvalor = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].monetario(o.cobvalor, true);
      this.form.cob = { 'rua': o.cobrua, 'numero': o.cobnumero, 'compl': o.cobcompl, 'cep': o.cobcep, 'bairro': o.cobbairro, 'cidade': o.cobcidade, 'uf': o.cobuf, 'referencia': o.cobreferencia };
      this.form.end = { 'rua': o.endrua, 'numero': o.endnumero, 'compl': o.endcompl, 'cep': o.endcep, 'bairro': o.endbairro, 'cidade': o.endcidade, 'uf': o.enduf, 'referencia': o.endreferencia };
    },
    saveForm: function saveForm() {
      var p = '';
      for (p in this.form.cob) {
        this.form['cob' + p] = this.form.cob[p];
      }delete this.form.cob;
      for (p in this.form.end) {
        this.form['end' + p] = this.form.end[p];
      }delete this.form.end;
      this.save(this.form);
    },
    addItem: function addItem(item, listname, index) {
      if (index === -1) {
        this.form[listname].push(item);
      } else {
        this.form[listname][index] = item;
      }
    },
    removeItem: function removeItem(listname, index) {
      this.form[listname].splice(index, 1);
    },
    closeForm: function closeForm() {
      this.$router.go(-1);
    },
    maskCnpjInput: function maskCnpjInput(e) {
      e.target.value = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].cnpj(e.target.value);
    },
    maskIeInput: function maskIeInput(e) {
      e.target.value = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].ie(e.target.value);
    },
    maskMonetarioInput: function maskMonetarioInput(e) {
      e.target.value = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].monetario(e.target.value);
    }
  },
  created: function created() {
    var grupo = this.$route.params.grupo;
    var cod = parseInt(this.$route.params.id);
    if (grupo !== undefined && cod === 0) {
      this.crud_action = 'Nova Filial';
      this.form.grupo = grupo;
    } else if (cod > 0) {
      this.crud_action = 'Alterando';
      this.load({ 'cod': cod });
    } else {
      this.crud_action = 'Novo';
    }
  }
});

/***/ }),

/***/ "o//j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oB25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/emails"}},[_vm._v("Emails")]),_vm._v(" » "),_c('router-link',{attrs:{"to":"/email/c/0"}},[_vm._v("Adicionar")])],1)]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.emails),function(email){return _c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(email.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-list",attrs:{"title":"Lista de Destinatários"},on:{"click":function($event){$event.preventDefault();_vm.select4list(email.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-envelope",attrs:{"title":"Enviar para Lista"},on:{"click":function($event){$event.preventDefault();_vm.select4send(email.cod)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(email.assunto))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('b',{staticClass:"text-muted"},[_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(email.enviados))]),_vm._v(" / "+_vm._s(email.total)+"\n        ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(email.dt))])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("#")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("Assunto")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("Enviados / Total")]),_vm._v(" "),_c('td',[_vm._v("Data")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oR8k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist',
  data: function data() {
    return {
      loading: false,
      clientes: []
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getcliente.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        if (response.body.length > 0) {
          this.clientes = response.body;
        } else {
          this.clientes = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/cliente/' + cod });
    },
    select4agenda: function select4agenda(cod) {
      this.$router.push({ path: '/agenda/c/' + cod });
    },
    select4addnew: function select4addnew(grupo) {
      this.$router.push({ path: '/cliente/' + grupo + '/0' });
    }
  },
  created: function created() {
    this.maskCnpj = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].cnpj;
    this.maskMonetario = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].monetario;
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_1__Mask_js__["a" /* default */].telefone;
    var grupo = this.$route.params.grupo;
    var keyword = this.$route.query.s;
    this.selflink = '/clientes/cob/' + grupo;
    this.load({ 'grupo': grupo, 'keyword': keyword });
  },
  watch: {
    '$route': function $route(to, from) {
      var grupo = this.$route.params.grupo;
      var keyword = this.$route.query.s;
      this.load({ 'grupo': grupo, 'keyword': keyword });
    }
  }
});

/***/ }),

/***/ "oVgx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'emailrel',
  data: function data() {
    return {
      loading: false,
      showForm: false,
      nocollapse: false,
      rel: 0,
      pacotes: [],
      pacotesAtu: 0,
      form: {
        codatu: 0,
        packname: '',
        chavecliente: '',
        anotacoes: ''
      }
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getpack.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        var _this = this;

        // console.log(response.body)
        if (response.body.status) {
          this.pacotes = response.body.rows;
          if (this.rel === 1) {
            this.pacotesAtu = 0;
            this.pacotes.forEach(function (item) {
              if (item.dt_download !== null) _this.pacotesAtu++;
            });
          }
        } else {
          this.pacotes = [];
        }
      }, function (error) {
        console.log(error);
      });
    },
    loadAnotacao: function loadAnotacao(codatu, chavecliente) {
      var url = './api/php/getpack.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'codatu': codatu, 'chavecliente': chavecliente })).then(function (response) {
        console.log(response);
        if (response.body.status) {
          this.fetchDataAnotacao(response.body.result);
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Ops...', response.body.erro, 'error');
          this.closeForm();
        }
      }, function (error) {
        console.log(error);
        this.closeForm();
      });
    },
    updateDtDownload: function updateDtDownload(codatu, chavecliente, status) {
      var url = './api/php/addpack.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'codatu': codatu, 'chavecliente': chavecliente, 'status': status })).then(function (response) {
        console.log(response);
        if (response.body.status) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Ok', '', 'success');
          if (this.$route.params.id !== undefined) {
            this.rel = 1;
            this.load({ 'rel': true, 'cod': this.$route.params.id });
          } else {
            this.rel = 0;
            this.load({ 'rel': true });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Ops...', response.body.erro, 'error');
          this.closeForm();
        }
      }, function (error) {
        console.log(error);
        this.closeForm();
      });
    },
    saveAnotacoes: function saveAnotacoes() {
      var url = './api/php/addpack.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'codatu': this.form.codatu, 'chavecliente': this.form.chavecliente, 'anotacoes': this.form.anotacoes })).then(function (response) {
        console.log(response);
        if (response.body.status) {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Ok', '', 'success');
          this.closeForm();
        } else {
          __WEBPACK_IMPORTED_MODULE_1_sweetalert___default()('Ops...', response.body.erro, 'error');
          this.closeForm();
        }
      }, function (error) {
        console.log(error);
        this.closeForm();
      });
    },
    fetchDataAnotacao: function fetchDataAnotacao(o) {
      this.form.codatu = o.cod;
      this.form.packname = o.packname;
      this.form.chavecliente = o.chavecliente;
      this.form.anotacoes = o.anotacoes;
      this.showForm = true;
    },
    closeForm: function closeForm() {
      this.showForm = false;
      this.form.codatu = 0;
      this.form.packname = '';
      this.form.chavecliente = '';
      this.form.anotacao = '';
    },
    select4thispack: function select4thispack(cod) {
      this.$router.push({ path: '/pacotes/' + cod });
    },
    formatData: function formatData(date) {
      return date !== undefined && date !== null ? date.substring(8, 11) + '-' + date.substring(5, 7) + '-' + date.substring(0, 4) : '';
    },
    percentual: function percentual(amostra, total, index) {
      this.pacotes[index].percent = (amostra / total * 100).toFixed(2);
    },
    collapseAll: function collapseAll() {
      if (this.nocollapse) {
        this.$router.push({ path: '?lap=0' });
      } else {
        this.$router.push({ path: '/pacotes' });
      }
    }
  },
  created: function created() {
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_2__Mask_js__["a" /* default */].telefone;
    if (this.$route.query.lap === '0') {
      console.log('No colapse set true! via created');
      this.nocollapse = true;
    }
    if (this.$route.params.id !== undefined) {
      if (this.$route.params.id === 'resumo') {
        console.log('Relatório por Atualização');
        this.rel = 2;
        this.load({ 'rel': true, 'cod': 0 });
      } else {
        this.rel = 1;
        this.load({ 'rel': true, 'cod': this.$route.params.id });
      }
    } else {
      console.log('Relatorio clientes');
      this.rel = 0;
      this.load({ 'rel': true });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (this.$route.query.lap === '0') {
        this.nocollapse = true;
        console.log('No colapse set true! via watch');
      }
      if (this.$route.params.id !== undefined) {
        if (this.$route.params.id === 'resumo') {
          console.log('Relatório por Atualização');
          this.rel = 2;
          this.load({ 'rel': true, 'cod': 0 });
        } else {
          this.rel = 1;
          this.load({ 'rel': true, 'cod': this.$route.params.id });
        }
      } else {
        console.log('Relatorio clientes');
        this.rel = 0;
        this.load({ 'rel': true });
      }
    }
  }
});

/***/ }),

/***/ "pUCz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('label',{staticClass:"col-sm-12"},[_vm._v("\n        Acesso\n        "),(_vm.showform==false)?_c('a',{staticClass:"glyphicon glyphicon-plus",on:{"click":function($event){$event.preventDefault();_vm.showform=true;_vm.focus()}}}):_vm._e(),_vm._v(" "),(_vm.showform==true)?_c('small',{staticClass:"text-primary"},[_c('b',[_vm._v("Pressione ESC para sair")])]):_vm._e()]),_vm._v(" "),(_vm.showform)?_c('div',{staticClass:"col-sm-12 form",on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.add()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.reset()}]}},[_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptEndereco),expression:"iptEndereco"}],ref:"iptendereco",staticClass:"form-control",attrs:{"type":"text","placeholder":"Endereço Externo"},domProps:{"value":(_vm.iptEndereco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iptEndereco=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptDescricao),expression:"iptDescricao"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Endereço Local / Observações"},domProps:{"value":(_vm.iptDescricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iptDescricao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptUsuario),expression:"iptUsuario"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Usuário"},domProps:{"value":(_vm.iptUsuario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iptUsuario=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptSenha),expression:"iptSenha"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Senha"},domProps:{"value":(_vm.iptSenha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iptSenha=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.add()}}},[_vm._v("Adicionar")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('ul',{staticClass:"list-inline"},_vm._l((_vm.acessos),function(acesso,index){return _c('li',[_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(acesso.descricao))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(acesso.endereco))]),_c('br'),_vm._v(" "),_c('small',[_c('b',[_vm._v("u:")]),_vm._v(" "+_vm._s(acesso.u))]),_c('br'),_vm._v(" "),_c('small',[_c('b',[_vm._v("s:")]),_vm._v(" "+_vm._s(acesso.s))]),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-pencil",on:{"click":function($event){$event.preventDefault();_vm.update(index)}}}),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-remove",on:{"click":function($event){$event.preventDefault();_vm.remove(index)}}})])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pUW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/agenda"}},[_vm._v("Agenda")]),_vm._v(" » \n          "+_vm._s(_vm.currWeekText)+"\n          "),_c('span',{staticClass:"spancalendar"},[(!_vm.showCalendar)?_c('i',{staticClass:"glyphicon glyphicon-calendar",on:{"click":function($event){_vm.showCalendar=true}}}):_vm._e(),_vm._v(" "),(_vm.showCalendar)?_c('Calendario',{staticClass:"calendario",on:{"pickWeek":_vm.setWeek}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"pull-right ferias",on:{"click":function($event){_vm.showFerias()}}},[_vm._v("\n            Férias "),_c('i',{staticClass:"glyphicon glyphicon-time"})])],1)])])]),_vm._v(" "),(_vm.week.length)?_c('div',{staticClass:"col-sm-12 week"},_vm._l((_vm.week),function(day){return _c('div',{class:day.s === 0 || day.s === 6? 'col-sm-1' : 'col-sm-2'},[_c('h2',{class:_vm.today === day.yyyymmdd? 'bg-primary' : ''},[_vm._v(_vm._s(day.d))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.weekNames[day.s]))]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.tasks[day.yyyymmdd]),function(compromisso){return _c('span',[_c('small',[_c('cite',[_vm._v(_vm._s(compromisso.razao.toUpperCase()))]),_vm._v(" "),_c('span',{staticClass:"label label-default"},[_vm._v(_vm._s(compromisso.fantasia))])]),_vm._v(" "),_c('b',[_vm._v(_vm._s(compromisso.hora))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(compromisso.funcionarionome))]),_vm._v(" "),_c('i',{staticClass:"glyphicon glyphicon-pencil",on:{"click":function($event){_vm.select4edit(compromisso.cod)}}}),_c('br'),_vm._v(" "),(compromisso.endcidade!=='')?_c('small',[_vm._v(_vm._s(compromisso.endcidade))]):_c('small',[_vm._v(_vm._s(compromisso.cobcidade))]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){$event.preventDefault();_vm.addNewWithDate(day.yyyymmdd)}}},[_vm._v("+ Adicionar")])],2)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pgFT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pjwG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliForm_vue__ = __webpack_require__("nwGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3938ed2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliForm_vue__ = __webpack_require__("WB92");
function injectStyle (ssrContext) {
  __webpack_require__("AELy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3938ed2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3938ed2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qJCj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qSPT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r5Cq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mask_js__ = __webpack_require__("HVS0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'telefone',
  props: ['telefones'],
  data: function data() {
    return {
      showform: false,
      iptNumero: '',
      iptDescricao: '',
      index: -1
    };
  },

  methods: {
    add: function add() {
      var item = { 'numero': this.iptNumero, 'descricao': this.iptDescricao };
      this.$emit('add', item, 'telefone', this.index);
      this.reset();
    },
    update: function update(index) {
      var telefone = this.telefones[index];
      this.iptNumero = telefone.numero;
      this.iptDescricao = telefone.descricao;
      this.index = index;
      this.showform = true;
      this.focus();
    },
    remove: function remove(index) {
      this.$emit('remove', 'telefone', index);
    },
    maskTelefoneInput: function maskTelefoneInput(e) {
      e.target.value = this.maskTelefone(e.target.value);
    },
    focus: function focus() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.iptnumero.focus();
      });
    },
    reset: function reset() {
      this.showform = false;
      this.iptNumero = '';
      this.iptDescricao = '';
      this.index = -1;
    }
  },
  created: function created() {
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_0__Mask_js__["a" /* default */].telefone;
  }
});

/***/ }),

/***/ "rae0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemRel_vue__ = __webpack_require__("2T5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030b9d15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemRel_vue__ = __webpack_require__("Yyhu");
function injectStyle (ssrContext) {
  __webpack_require__("eEVu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-030b9d15"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MensagemRel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030b9d15_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MensagemRel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rjS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackRel_vue__ = __webpack_require__("oVgx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81658e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackRel_vue__ = __webpack_require__("lh58");
function injectStyle (ssrContext) {
  __webpack_require__("2zjs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81658e32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackRel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81658e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackRel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rlO3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('label',{staticClass:"col-sm-12"},[_vm._v("\n        Telefone\n        "),(_vm.showform==false)?_c('a',{staticClass:"glyphicon glyphicon-plus",on:{"click":function($event){$event.preventDefault();_vm.showform=true;_vm.focus()}}}):_vm._e(),_vm._v(" "),(_vm.showform==true)?_c('small',{staticClass:"text-primary"},[_c('b',[_vm._v("Pressione ESC para sair")])]):_vm._e()]),_vm._v(" "),(_vm.showform)?_c('div',{staticClass:"col-sm-12 form",on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.add()},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.reset()}]}},[_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptNumero),expression:"iptNumero"}],ref:"iptnumero",staticClass:"form-control",attrs:{"type":"text","placeholder":"Número Telefone"},domProps:{"value":(_vm.iptNumero)},on:{"keyup":function($event){_vm.maskTelefoneInput($event)},"focusout":function($event){_vm.maskTelefoneInput($event)},"input":function($event){if($event.target.composing){ return; }_vm.iptNumero=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.iptDescricao),expression:"iptDescricao"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Contato"},domProps:{"value":(_vm.iptDescricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.iptDescricao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();_vm.add()}}},[_vm._v("Adicionar")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('ul',{staticClass:"list-inline"},_vm._l((_vm.telefones),function(telefone,index){return _c('li',[_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero)))]),_c('br'),_vm._v(" "),_c('small',[_vm._v("..."+_vm._s(telefone.descricao))]),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-pencil",on:{"click":function($event){$event.preventDefault();_vm.update(index)}}}),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-remove",on:{"click":function($event){$event.preventDefault();_vm.remove(index)}}})])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sAS0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sYB9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sh+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelCobDocs_vue__ = __webpack_require__("eqdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe3ed1f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelCobDocs_vue__ = __webpack_require__("/wwa");
function injectStyle (ssrContext) {
  __webpack_require__("SWow")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fe3ed1f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CliRelCobDocs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fe3ed1f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CliRelCobDocs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sj3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t6hT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Mensagem',
  components: {},
  data: function data() {
    return {
      logado: false
    };
  },

  methods: {},
  created: function created() {
    this.logado = this.$root.auth;
  }
});

/***/ }),

/***/ "tVHs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__ = __webpack_require__("Y7kT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Calendar__ = __webpack_require__("iyFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert__ = __webpack_require__("thjQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    wysiwyg: __WEBPACK_IMPORTED_MODULE_1__Wysiwyg__["a" /* default */], Calendario: __WEBPACK_IMPORTED_MODULE_2__Calendar__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      showCalendarDtInicio: false,
      showCalendarDtFim: false,
      crud_action: '',
      form: {
        cod: 0,
        msg: '',
        dt_inicio: undefined,
        dt_fim: undefined,
        atucodig: ' '
      }
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getmsg.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        this.fetchData(response.body);
      }, function (error) {
        console.log(error);
      });
    },
    fetchData: function fetchData(o) {
      this.form = o;
      this.form.atucodig = o.atucodig === -1 ? '' : o.atucodig;
      this.form.dt_inicio = o.dt_inicio.replace(/-/g, '').substring(0, 8);
      this.form.dt_fim = o.dt_fim.replace(/-/g, '').substring(0, 8);
      this.$refs.dtiniciodisplay.value = this.formatData(this.form.dt_inicio);
      this.$refs.dtfimdisplay.value = this.formatData(this.form.dt_fim);
      this.$refs.msg.setContent(o.msg);
    },
    save: function save() {
      if (this.form.dt_inicio === undefined || this.form.dt_fim === undefined) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Ops...', 'Os campos referentes a DATA de inicio e término são obrigatórios', 'error');
      } else {
        this.form.msg = this.$refs.msg.getContent();
        var url = './api/php/addmsg.php';
        this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form)).then(function (response) {
          console.log(response.body);
          if (response.body.status) {
            __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Mensagem Cadastrada', '', 'success');
          }
          this.closeForm();
        }, function (error) {
          console.log(error);
        });
      }
    },
    remove: function remove() {
      var url = './api/php/removemsg.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form)).then(function (response) {
        console.log(response.body);
        if (response.body.status) {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Ok', response.body.msg, 'success');
          this.closeForm();
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert___default()('Ops...', response.body.erro, 'error');
        }
      }, function (error) {
        console.log(error);
      });
    },
    setDate: function setDate(date) {
      console.log('DtPicked: ' + date);
      if (this.showCalendarDtInicio === true) {
        this.showCalendarDtInicio = false;
        this.form.dt_inicio = date;
        this.$refs.dtiniciodisplay.value = this.formatData(date);
      } else {
        this.showCalendarDtFim = false;
        this.form.dt_fim = date;
        this.$refs.dtfimdisplay.value = this.formatData(date);
      }
    },
    formatData: function formatData(date) {
      if (date.length > 0) {
        return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4);
      }
    },
    closeForm: function closeForm() {
      this.$router.push({ path: '/mensagens' });
    }
  },
  created: function created() {
    var crud = this.$route.params.crud;
    var cod = this.$route.params.id;
    if (crud === 'c') {
      // Criar nova MSg
      console.log('Criando nova msg');
      this.crud_action = 'Novo';
    } else if (crud === 'u') {
      // Altera uma Msg
      console.log('Alterando um email');
      this.crud_action = 'Alterando (#' + cod + ')';
      this.load({ 'cod': cod });
    } else {
      console.log('CRUD INVÁLIDO EM FORM EMAIL');
    }
  }
});

/***/ }),

/***/ "uBZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ferias_vue__ = __webpack_require__("RxpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a40411_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ferias_vue__ = __webpack_require__("LYXq");
function injectStyle (ssrContext) {
  __webpack_require__("QvX/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06a40411"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ferias_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a40411_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ferias_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w0zJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.logado)?_c('div'):_c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__("lfLh");

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    navbarapp: __WEBPACK_IMPORTED_MODULE_1__components_Navbar__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {
    getStatusLogin: function getStatusLogin(params) {
      var url = './api/php/login.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response);
        if (response.body.login) {
          var login = response.body.login;
          if (!login.status) {
            console.log('LOGIN ERR: ' + login.msg);
            this.logout();
          } else {
            console.log('LOGIN AUTH');
            this.letmein(login);
          }
        }
      }, function (error) {
        console.log(error);
      });
    },
    getStatusLogout: function getStatusLogout(params) {
      var url = './api/php/logout.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response);
        this.$root.auth = false;
        this.$router.push({ path: '/' });
      }, function (error) {
        console.log(error);
      });
    },
    letmein: function letmein(login) {
      this.$root.auth = true;
      this.$root.nome = login.nome;
      console.log('APP Ln: ' + login.nome);
      this.$root.cod = login.cod;
      this.$root.nivel = login.nivel;
    },
    logout: function logout() {
      this.getStatusLogout({});
    },
    focusIptSearch: function focusIptSearch() {
      this.$refs.cmpNavbar.focusIptSearch();
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (!this.$root.auth) {
        console.log('Cheking login via Router Change');
        this.getStatusLogin({});
      }
    }
  },
  created: function created() {
    console.log('Cheking login via Created');
    if (!this.$root.auth) this.getStatusLogin({});
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435187d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("hF4n");
function injectStyle (ssrContext) {
  __webpack_require__("Itdc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-435187d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435187d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xNas":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y4sZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/ferias"}},[_vm._v("Férias")])],1)]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.rows),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.ano))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.funcionario))]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(_vm.normalizeData(row.s1))+"\n        "),(row.s1==='')?_c('span',{staticClass:"calendario"},[(_vm.showCalendar===0)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendar=row.ano+'_'+row.cod}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]):_vm._e(),_vm._v(" "),(_vm.showCalendar===row.ano+'_'+row.cod)?_c('Calendario',{staticClass:"calendario",on:{"pickWeek":_vm.setWeek}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(_vm.normalizeData(row.s2))+"\n        "),(row.s1 !== '' && row.s2==='')?_c('span',{staticClass:"calendario"},[(_vm.showCalendar===0)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendar=row.ano+'_'+row.cod}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]):_vm._e(),_vm._v(" "),(_vm.showCalendar===row.ano+'_'+row.cod)?_c('Calendario',{staticClass:"calendario",on:{"pickWeek":_vm.setWeek}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(_vm.normalizeData(row.s3))+"\n        "),(row.s2 !== '' && row.s3 === '')?_c('span',{staticClass:"calendario"},[(_vm.showCalendar===0)?_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showCalendar=row.ano+'_'+row.cod}}},[_c('i',{staticClass:"glyphicon glyphicon-calendar"})]):_vm._e(),_vm._v(" "),(_vm.showCalendar===row.ano+'_'+row.cod)?_c('Calendario',{staticClass:"calendario",on:{"pickWeek":_vm.setWeek}}):_vm._e()],1):_vm._e()])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Ano")]),_vm._v(" "),_c('td',[_vm._v("Funcionário")]),_vm._v(" "),_c('td',[_vm._v("Semana 1")]),_vm._v(" "),_c('td',[_vm._v("Semana 2")]),_vm._v(" "),_c('td',[_vm._v("Semana 3")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yLTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__ = __webpack_require__("iyFI");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Calendario: __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__["a" /* default */]
  },
  data: function data() {
    return {
      weekNames: ['DOM', 'SEGUNDA', 'TERÇA', 'QUARTA', 'QUINTA', 'SEXTA', 'SÁB'],
      showCalendar: false,
      currWeekText: '',
      week: [],
      tasks: {}
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/getagenda.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        this.tasks = response.body;
      }, function (error) {
        console.log(error);
      });
    },
    setWeek: function setWeek(aDay, zDay, week) {
      console.log(aDay + '-' + zDay);
      this.week = week;
      this.currWeekText = this.normalizeDate(aDay) + ' a ' + this.normalizeDate(zDay);
      this.showCalendar = false;
      this.load({ 'adate': aDay, 'zdate': zDay });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/agenda/u/' + cod });
    },
    addNewWithDate: function addNewWithDate(dt) {
      this.$root.globalAgeFormDt = dt;
      this.$router.push({ path: '/clientes/sup' });
    },
    normalizeDate: function normalizeDate(dt) {
      return dt.substring(6, 8) + '/' + dt.substring(4, 6) + '/' + dt.substring(2, 4);
    },
    showFerias: function showFerias() {
      this.$router.push({ path: '/ferias' });
    }
  },
  created: function created() {
    this.today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  }
});

/***/ }),

/***/ "yfo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__ = __webpack_require__("iyFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Mask_js__ = __webpack_require__("HVS0");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'datalist',
  components: { Calendario: __WEBPACK_IMPORTED_MODULE_1__Calendar_vue__["a" /* default */] },
  data: function data() {
    return {
      showFilters: false,
      showCalendarMin: false,
      showCalendarMax: false,
      loading: false,
      dthoje: undefined,
      filters: {
        coduser: '*',
        flag: '*',
        situacao: '*',
        dtmin: '1900-01-01 00:00:00',
        dtmax: '9999-12-31 00:00:00',
        groupby: 'codcli'
      },
      fatos: {},
      numheaders: 0,
      numrows: 0
    };
  },

  methods: {
    load: function load() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var url = './api/php/gethistorico.php';
      this.$http.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)).then(function (response) {
        console.log(response.body);
        var json = response.body;
        if (json.status) {
          this.fatos = json.rows;
          this.numheaders = json.numheaders;
          this.numrows = json.numrows;
        }
      }, function (error) {
        console.log(error);
      });
    },
    select4edit: function select4edit(cod) {
      this.$router.push({ path: '/tarefa/u/' + cod });
    },
    setDateMin: function setDateMin(dt) {
      var aaaa = dt.substring(0, 4);
      var mm = dt.substring(4, 6);
      var dd = dt.substring(6, 8);
      this.filters.dtmin = aaaa + '-' + mm + '-' + dd + ' 00:00:00';
      this.showCalendarMin = false;
      this.$refs.dtmindisplay.value = dd + '/' + mm + '/' + aaaa;
    },
    setDateMax: function setDateMax(dt) {
      var aaaa = dt.substring(0, 4);
      var mm = dt.substring(4, 6);
      var dd = dt.substring(6, 8);
      this.filters.dtmax = aaaa + '-' + mm + '-' + dd + ' 23:59:59';
      this.showCalendarMax = false;
      this.$refs.dtmaxdisplay.value = dd + '/' + mm + '/' + aaaa;
    },
    searchWithFilters: function searchWithFilters() {
      this.load({ 'keyword': this.$route.query.s, 'filters': this.filters });
      console.log('Busca por Filtros...');
    },
    select4tarefa: function select4tarefa(cod) {
      this.$router.push({ path: '/tarefa/u/' + cod });
    },
    select4agenda: function select4agenda(cod) {
      this.$router.push({ path: '/agenda/u/' + cod });
    },
    normalizeDate: function normalizeDate(dt) {
      return dt.substring(6, 8) + '/' + dt.substring(4, 6) + '/' + dt.substring(0, 4);
    }
  },
  created: function created() {
    this.maskTelefone = __WEBPACK_IMPORTED_MODULE_2__Mask_js__["a" /* default */].telefone;
    var keyword = this.$route.query.s;
    var codcli = this.$route.params.id;
    if (codcli > 0) {
      this.load({ 'keyword': keyword, 'codcli': codcli, 'filters': false });
    } else {
      this.load({ 'keyword': keyword, 'filters': false });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      var keyword = this.$route.query.s;
      var codcli = this.$route.params.id;
      if (codcli > 0) {
        this.load({ 'keyword': keyword, 'codcli': codcli, 'filters': false });
      } else {
        this.load({ 'keyword': keyword, 'filters': false });
      }
    }
  }
});

/***/ }),

/***/ "yg3c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("Aguarde ...")]):_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-sm-12 text-left"},[_c('h3',[_c('router-link',{attrs:{"to":"/clientes/sup"}},[_vm._v("Suporte")]),_vm._v(" » \n      "),_c('router-link',{attrs:{"to":_vm.selflink}},[_vm._v(_vm._s(this.$route.params.grupo))])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.clientes.length)+" resultado(s) encontrados")]),_vm._v(" "),(this.$route.query.s)?_c('small',[_vm._v(" que contém '"+_vm._s(this.$route.query.s)+"'")]):_vm._e()]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_vm._l((_vm.clientes),function(cliente){return _c('tr',[_c('td',[_c('a',{staticClass:"glyphicon glyphicon-pencil",attrs:{"title":"Editar"},on:{"click":function($event){$event.preventDefault();_vm.select4edit(cliente.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-book",attrs:{"title":"Agenda"},on:{"click":function($event){$event.preventDefault();_vm.select4agenda(cliente.cod)}}})]),_vm._v(" "),_c('td',[_c('a',{staticClass:"glyphicon glyphicon-plus",attrs:{"title":"Adicionar filial não pagadora"},on:{"click":function($event){$event.preventDefault();_vm.select4addnew(cliente.grupo)}}})]),_vm._v(" "),(cliente.cobvalor>0)?_c('td',{staticClass:"lt500"},[_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.maskCnpj(cliente.cnpj)))])]):_c('td',{staticClass:"lt500"},[_vm._v(_vm._s(_vm.maskCnpj(cliente.cnpj)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.razao)),_c('br'),_c('small',[_vm._v(_vm._s(cliente.fantasia))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.endcidade !== '' ? cliente.endcidade : cliente.cobcidade))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cliente.cobdia))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.maskMonetario(cliente.cobvalor, true)))]),_vm._v(" "),_c('td',_vm._l((cliente.telefone),function(telefone){return _c('span',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.maskTelefone(telefone.numero))),_c('br')])})),_vm._v(" "),_vm._m(1,true)])})],2),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"lt500"},[_vm._v("cnpj")]),_vm._v(" "),_c('td',[_vm._v("razao")]),_vm._v(" "),_c('td',[_vm._v("cidade")]),_vm._v(" "),_c('td',[_vm._v("dia")]),_vm._v(" "),_c('td',[_vm._v("valor")]),_vm._v(" "),_c('td',[_vm._v("contato")]),_vm._v(" "),_c('td')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('a',{staticClass:"glyphicon glyphicon-pushpin",attrs:{"href":"","title":"Anotações"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zZ/U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.493c1790d5257e1d3d03.js